import React, { useContext, useEffect, useRef, useState } from "react";
import Header3 from "../components/Header3";
import { Card, Dropdown, Form, Modal } from "react-bootstrap";
import Footer2 from "../components/Footer2";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Slider from "react-slick";
import axios from "../AxiosInstance";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useAuth } from "../context/auth";
import { BASE_URL } from "../config/BaseUrls";
import { LanguageContext } from "../context/LanguageContext";
import toast from "react-hot-toast";
import { resolveBookImageUrl } from "../utils/urlHelpers";
const initialBooks = [
  {
    title: ["Normal People", ""],
    genre: "Fiction",
    eventDate: "WED, Oct 23 - 6:00 pm",
    ageGroup: "Age: 20-30",
    eventType: "Book Club",
    image: require("../pages/image/book1.png"),
  },
  {
    title: ["Normal People", ""],
    genre: "Crime",
    eventDate: "WED, Oct 23 - 6:00 pm",
    ageGroup: "Age: 20-30",
    eventType: "Book Club",
    image: require("../pages/image/book2.png"),
  },
  {
    title: ["Normal People", ""],
    genre: "Fiction",
    eventDate: "WED, Oct 23 - 6:00 pm",
    ageGroup: "Age: 20-30",
    eventType: "Book Club",
    image: require("../pages/image/book3.png"),
  },

  // Add more book data here as needed
];
const initialBooks1 = [
  {
    title: ["Your own book", ""],
    genre: "Fiction",
    eventDate: "WED, Oct 23 - 6:00 pm",
    ageGroup: "Age: 20-30 ",
    eventType: "Silent Reading",
    image: require("../pages/image/book7.jpg"),
  },
  {
    title: ["Your own book", ""],
    genre: "Crime",
    eventDate: "WED, Oct 23 - 6:00 pm",
    ageGroup: "Age: 20-30 ",
    eventType: "Silent Reading",
    image: require("../pages/image/book7.jpg"),
  },
  {
    title: ["Your own book", ""],
    genre: "Crime",
    eventDate: "WED, Oct 23 - 6:00 pm",
    ageGroup: "Age: 20-30 ",
    eventType: "Silent Reading",
    image: require("../pages/image/book7.jpg"),
  },

  // Add more book data here as needed
];

const bookspst = [
  {
    title: ["Normal People", ""],
    genre: "Fiction",
    eventDate: "WED, Oct 23 - 6:00 pm",
    ageGroup: "Age: 20-30",
    eventType: "Book Club",
    image: require("../pages/image/book1.png"),
  },
  {
    title: ["Normal People", ""],
    genre: "Fiction",
    eventDate: "WED, Oct 23 - 6:00 pm",
    ageGroup: "Age: 20-30",
    eventType: "Book Club",
    image: require("../pages/image/book2.png"),
  },

];

const countries = [
  "Australia",
  "Canada",
  "Germany",
  "France",
  "United States",
  // "United Kingdom",

  "Brazil",
  "Mexico",

  // Add other countries as needed
];

const settings = {
  // dots: true, // Show dots for navigation
  infinite: true, // Infinite looping
  speed: 500, // Transition speed
  slidesToShow: 3, // Show 3 books at a time
  slidesToScroll: 1, // Move 1 book at a time
  draggable: true, // Allow drag functionality
  swipe: true, // Allow touch swipe
  arrows: false, // Hide default navigation arrows
  responsive: [
    {
      breakpoint: 768, // For screen widths <= 768px
      settings: {
        slidesToShow: 3.5, // Show 2 books at a time
      },
    },
    {
      breakpoint: 450, // For screen widths <= 450px
      settings: {
        slidesToShow: 3, // Show 2.5 books at a time
        centerMode: true, // Center the active slide
        centerPadding: "10px", // Padding around the center item
      },
    },
    {
      breakpoint: 400, // For screen widths <= 450px
      settings: {
        slidesToShow: 2.2, // Show 2.5 books at a time
        centerMode: true, // Center the active slide
        centerPadding: "30px", // Padding around the center item
      },
    },
  ],
};

const Leading = () => {
  const { lg } = useContext(LanguageContext);

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  // const [books, setBooks] = useState([

  // );
  const [bookSelected, setBookSelected] = useState(null);
  const [selectedImageLaed, setSelectedImageLaed] = useState(null);
  const fileInputRefLaed = useRef(null);

  // Load the selected image from localStorage on component mount
  useEffect(() => {
    const storedImageLaed = localStorage.getItem("leadingProfileImage");
    if (storedImageLaed) {
      setSelectedImageLaed(storedImageLaed);
    }
  }, []);

  const handleButtonClickLaed = () => {
    if (fileInputRefLaed.current) {
      fileInputRefLaed.current.click();
    }
  };

  const handleFileChangeLaed = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImageLaed(reader.result); // Set the selected image as a base64 URL
        localStorage.setItem("leadingProfileImage", reader.result); // Save to localStorage
      };
      reader.readAsDataURL(file); // Read the file as a data URL
    }
  };

  const navigate = useNavigate();

  const [visibleCard, setVisibleCard] = useState(null); // Tracks which card is visible

  const handleEditClick = (index) => {
    setVisibleCard(index); // Show the card corresponding to the clicked index
  };

  const handleCancel = () => {
    setVisibleCard(null); // Hide the card
  };

  const [visibleCard1, setVisibleCard1] = useState(null); // Tracks which card is visible
  const [attendees, setAttendees] = useState([]);
  const [wShowCanc, setWShowCanc] = useState(false);
  const [groupChatName, setGroupChatName] = useState("");
  const handleCloseCanc = () => {
    setWShowCanc(false);
  };
  const handleEditClick1 = async (bookId) => {
    setVisibleCard1(bookId); // Show the card corresponding to the clicked index
    try {
      const res = await axios.get(`/api/v1/books/getattendeesusers/${bookId}`);

      setAttendees(res.data.attendees);
      q6Show(true);
    } catch (err) {
      console.error("Failed to fetch attendees", err);
    }
  };

  const handleCancelAttendance = async (bookId) => {
    if (!bookId) {
      console.error("Book ID is missing!");
      return;
    }

    try {
      const res = await axios.put(`/api/v1/books/cancel-attendees/${bookId}`);
      console.log(res.data.message);
      setAttendees([]); // frontend se bhi hatao
      toast.success("Your attendance has been cancelled successfully.");
      fetchLatestBooks();
      handleCloseC(true);
    } catch (err) {
      console.error("Cancel error:", err);
    }
  };

  const handleCancel1 = () => {
    setVisibleCard1(null); // Hide the card
  };
  const handleGoing1 = () => {
    setVisibleCard1(null); // Hide the card
  };

  const [selectedGoing, setSelectedGoing] = useState(() => {
    // Load saved options from localStorage or set default "Going" for all books
    const savedOptions =
      JSON.parse(localStorage.getItem("selectedOptionsgoing1")) || [];
    if (savedOptions.length === 0) {
      // Create default "Going" status for all books
      const defaultOptions = initialBooks.map(() => "Going");
      localStorage.setItem(
        "selectedOptionsgoing1",
        JSON.stringify(defaultOptions)
      );
      return defaultOptions;
    }
    return savedOptions;
  });

  // Load saved options from localStorage
  useEffect(() => {
    const savedOptionsGoing =
      JSON.parse(localStorage.getItem("selectedOptionsgoing1")) || {};
    setSelectedGoing(savedOptionsGoing);
  }, []);

  // Save selected option to localStorage
  const handleOptionChangeGoing = (index, value) => {
    const updatedOptionsGoing = { ...selectedGoing, [index]: value };
    setSelectedGoing(updatedOptionsGoing);
    localStorage.setItem(
      "selectedOptionsgoing1",
      JSON.stringify(updatedOptionsGoing)
    );
  };

  const handleGoing = () => {
    setVisibleCard(null); // Hide the card
  };
  const [selectedGoingSilent, setSelectedGoingSilent] = useState(() => {
    // Load saved options from localStorage or set default "Going" for all books
    const savedOptions =
      JSON.parse(localStorage.getItem("selectedOptionsgoingsilent")) || [];
    if (savedOptions.length === 0) {
      // Create default "Going" status for all books
      const defaultOptions = initialBooks1.map(() => "Going");
      localStorage.setItem(
        "selectedOptionsgoingsilent",
        JSON.stringify(defaultOptions)
      );
      return defaultOptions;
    }
    return savedOptions;
  });

  // Load saved options from localStorage
  useEffect(() => {
    const savedOptionsGoingSilent =
      JSON.parse(localStorage.getItem("selectedOptionsgoingsilent")) || {};
    setSelectedGoingSilent(savedOptionsGoingSilent);
  }, []);

  const [show, setShow] = useState(false); // For signup modal

  // Handle closing both modals
  const handleClose = () => {
    setShow(false); // Close signup modal
    localStorage.setItem("modalClosedL", "true");
  };

  // Handle opening signup modal
  const handleShow = () => {
    setShow(true); // Open signup modal
  };

  const handleCountrySelect = (event) => {
    const selectedCountry = event.target.value;
    // if (selectedCountry) {
    //   navigate(`/groupeventcreation`); // Replace with your actual route
    // }
  };

  const location = useLocation();

  // Check location state to open modal if triggered
  useEffect(() => {
    const isModalClosedL = localStorage.getItem("modalClosedL");
    if (location.state?.show && !isModalClosedL) {
      setShow(true);
    }
  }, [location.state]);

  // Load books from localStorage or use the default initialBooks
  const [books, setBooks] = useState(() => {
    const savedBooks = localStorage.getItem("booksRemoveLead18");
    return savedBooks ? JSON.parse(savedBooks) : initialBooks;
  });

  const handleNotGoing = (indexToRemove) => {
    const updatedBooks = books.filter((_, index) => index !== indexToRemove);

    // Update state and save to localStorage
    setBooks(updatedBooks);
    handleShowW(false);
    handleCloseW(true);
    setVisibleCard1(null);

    localStorage.setItem("booksRemoveLead18", JSON.stringify(updatedBooks));
  };

  useEffect(() => {
    // Save books to localStorage whenever they change
    localStorage.setItem("books", JSON.stringify(books));
  }, [books]);

  // Second card
  const [books1, setBooks1] = useState(() => {
    const savedBooks = localStorage.getItem("booksRemove6");
    return savedBooks ? JSON.parse(savedBooks) : initialBooks1;
  });

  const handleNotGoing1 = (indexToRemove) => {
    const updatedBooks = books1.filter((_, index) => index !== indexToRemove);

    // Update state and save to localStorage
    setBooks1(updatedBooks);
    setVisibleCard(null);
    handleShowW1(false);

    localStorage.setItem("booksRemove6", JSON.stringify(updatedBooks));
  };

  useEffect(() => {
    // Save books to localStorage whenever they change
    localStorage.setItem("books1", JSON.stringify(books1));
  }, [books1]);

  const [wShow, setWShow] = useState(false); // For signup modal

  const handleCloseW = () => {
    setWShow(false);
  };
  const handleShowW = (index) => {
    setWShow(index); // Open  modal
    setVisibleCard1(null);
  };

  const [cShow, setCShow] = useState(null); // For signup modal

  const handleCloseC = () => {
    setCShow(false);
  };
  const handleShowC = (index) => {
    setCShow(index); // Open  modal
    // setVisibleCard(null);
  };

  const [wShow1, setWShow1] = useState(false); // For signup modal

  const handleCloseW1 = () => {
    setWShow1(false);
  };
  const handleShowW1 = (index) => {
    setWShow1(index); // Open  modal
    setVisibleCard(null);
  };

  const handleEventTypeClick = (eventType, eventId) => {
    const eventRoutes = {
      "Book Duo": "/meetorganizer",
      "Book Club": "/groupevent",
      "Silent Reading": "/silentreadingabout",
    };

    const route = eventRoutes[eventType];
    if (route) {
      navigate(`${route}?bookid=${eventId}`);
    } else {
      console.error("No route defined for this event type:", eventType);
    }
  };

  // ?model

  const [q6Show, setQ6Show] = useState(false); // For signup modal
  const handleQ6Close = () => {
    setQ6Show(false);
  };
  const handleQ6Show = () => {
    setQ6Show(true);
  };

  // FAtch User Details
  const [auth, setAuth] = useAuth();

  const userId = auth?.user?._id;

  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      if (!userId) return; // Don't make API call if userId is undefined
      try {
        const res = await axios.get(`api/v1/auth/user-profile/${userId}`);
        setUser(res.data.data);
      } catch (err) {
        console.error("Error:", err);
      }
    };

    fetchUser();
  }, [userId]);

  const [latestBooks, setLatestBooks] = useState([]);
  const fetchLatestBooks = async () => {
    try {
      const response = await axios.get(
        `api/v1/books/getlastestbooks/${userId}`
      );
      setLatestBooks(response.data.data);
    } catch (error) {
      console.error("Error fetching latest books:", error);
    }
  };
  useEffect(() => {
    fetchLatestBooks();
  }, []);

  const bookClubBooks = latestBooks.filter((book) => book.name === "Book Club");

  const booksilentBooks = latestBooks.filter(
    (book) => book.name === "Silent Reading"
  );
  const bookDuoBooks = latestBooks.filter((book) => book.name === "Book Duo");
  console.log(bookDuoBooks, "bookDuoBooks");
  const { bookId } = useParams(); // <-- now you have the correct bookId
  const handleGroupChatCreation = async (e) => {
    e.preventDefault();
    console.log("groupChatName", groupChatName);

    if (attendees.length === 0) {
      console.error("attendees is empty!");
      return;
    }
    try {
      const res = await axios.post(`/api/v1/chat/group`, {
        name: `${groupChatName?.name || ""} ${
          groupChatName?.dateInfo?.day || ""
        } ${groupChatName?.dateInfo?.month || ""} ${
          groupChatName?.dateInfo?.year || ""
        }`.trim(),
        users: JSON.stringify([...attendees?.map((u) => u._id), user._id]),
        user: user._id,
        event: groupChatName?._id,
      });
      console.log("Group created successfully:", res.data);
      toast.success("Group created successfully.");
      navigate("/chatChak");
    } catch (err) {
      console.error("Error adding book:", err);
      toast.error("Failed to add book.");
    }
  };
  return (
    <>
      <div className="leaddashheader">
        <Header3 />
      </div>

      <div className="alincenterawidth">
        <div
          className="highyauto"
          style={{
            backgroundColor: "#F2F2F2",
            height: "185px",
            alignItems: "center",
          }}
        >
          <div
            className="d-md-flex  justzomag11   mlmrleading gap-xl-5 gap-4 "
            style={{ paddingTop: "30px" }}
          >
            <div className="textsmctrlead   ">
              {/* Header */}
              <div className="d-sm-flex  gap-2 gap-md-3 ">
                <input
                  type="file"
                  accept="image/*"
                  ref={fileInputRefLaed}
                  style={{ display: "none" }} // Hide the input
                  onChange={handleFileChangeLaed} // Handle file change
                />
                <img
                  src={
                    user?.profileImage
                      ? BASE_URL + "/uploads/" + user.profileImage
                      : require("../pages/image/addphotoicon.png")
                  } // Show user-selected image or default image
                  alt="Profile"
                  className="rounded-circle widimg "
                  width="105px"
                  height="105px"
                  style={{ width: "105px", height: "105px" }}
                  //   style={{ width: "118px", height: "118px" }} // Set dimensions as needed
                  // onClick={handleButtonClickLaed} // Allow clicking on the image to upload a new one
                />
                <div className="text-center text-sm-start d-flex align-items-center flex-column justify-content-center">
                  <div
                    className=" mt-2 fw-bold fs-22 ftzpual text-dark "
                    style={{ lineHeight: "33.6px" }}
                  >
                    {user?.name}
                  </div>
                  {user?.isAmbassador && (
                    <>
                      <div
                        className="fw-normal ftzpual fs-22"
                        style={{ color: "#DF8244" }}
                      >
                        Ambassador
                      </div>
                      <div
                        className="fw600 fs-18 ftzpual  ftzgern"
                        style={{ color: "#2A2A2A" }}
                      >
                        {/* Level  */}
                        {lg?.level}1
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className=" mt-xl-4 mt-md-0 mt-2 pt-2 mx-lg-5 mlmreditbrns justify-content-center  d-flex flex-wrap gap-4">
              <button
                className="text-white rounded-1 fw-bold fs-18 btnedit2 ftzgern border-0 text-center"
                style={{
                  width: "153px",
                  height: "53px",
                  backgroundColor: "#34C3C9",
                }}
                onClick={() => navigate("/profile")}
              >
                {/* EDIT PROFILE */}
                {/* Edit Profile */}
                {lg?.editprf}
              </button>
              {/* OLD CODE - Future use: Ambassador conditional rendering */}
              {/* {user?.isAmbassador && (
                <>
                  <button
                    className="text-white  rounded-1 fw-bold btneditmeet ftzgern border-0 text-center"
                    style={{
                      width: "180px",
                      height: "53px",
                      backgroundColor: "#34C3C9",
                      fontSize: "18px",
                      lineHeight: "18px",
                    }}
                    // onClick={handleShow} // Trigger modal on click
                    onClick={() => navigate("/booksdetails")}
                  >
                    {lg?.cbclub}
                  </button>
                  <button
                    className="text-white  rounded-1 fw-bold btneditmeet ftzgern border-0 text-center"
                    style={{
                      width: "180px",
                      height: "53px",
                      backgroundColor: "#34C3C9",
                      fontSize: "18px",
                      lineHeight: "18px",
                    }}
                    onClick={() => navigate("./silentreading")} // Trigger modal on click
                  >
                    {lg?.cbsil}
                  </button>
                </>
              )} */}
              {/* NEW CODE: All users can create events */}
              <button
                className="text-white  rounded-1 fw-bold btneditmeet ftzgern border-0 text-center"
                style={{
                  width: "180px",
                  height: "53px",
                  backgroundColor: "#34C3C9",
                  fontSize: "18px",
                  lineHeight: "18px",
                }}
                // onClick={handleShow} // Trigger modal on click
                onClick={() => navigate("/booksdetails")}
              >
                {/* CREATE <br /> BOOK CLUB */}
                {/* Create <br /> Book Club */}
                {lg?.cbclub}
              </button>
              <button
                className="text-white  rounded-1 fw-bold btneditmeet ftzgern border-0 text-center"
                style={{
                  width: "180px",
                  height: "53px",
                  backgroundColor: "#34C3C9",
                  fontSize: "18px",
                  lineHeight: "18px",
                }}
                onClick={() => navigate("./silentreading")} // Trigger modal on click
              >
                {/* CREATE <br /> SILENT READING */}
                {/* Create <br /> Silent Reading */}
                {lg?.cbsil}
              </button>
              <button
                className="text-white rounded-1 fw-bold btneditmeet ftzgern  border-0 text-center"
                style={{
                  width: "180px",
                  height: "53px",
                  backgroundColor: "#34C3C9",
                  fontSize: "18px",
                  lineHeight: "18px",
                }}
                onClick={() => navigate("/createmeetup")}
              >
                {/* CREATE
              <br /> BOOK DUO{" "} */}
                {/* Create
                <br /> Book Duo */}
                {lg?.cbduo}
              </button>

              <Modal
                show={show}
                onHide={handleClose}
                centered
                className="custom-modalmeet"
              >
                <Modal.Header className=" border-0">
                  <img
                    className=" border-0 closebtn mt-4 top-0 "
                    src={require("../components/image/close.png")}
                    alt="logo"
                    onClick={handleClose}
                  />
                </Modal.Header>
                <Modal.Title
                  className="text-center text-dark fw-bold mt-3 modeltitlemeet"
                  style={{
                    fontSize: "42px",
                    lineHeight: "43.58px",
                  }}
                >
                  Welcome!
                </Modal.Title>
                <Modal.Body className="mx-auto">
                  <div
                    className="fs-5 fw600  text-center w-100 ftzcopy mt-5  "
                    style={{ maxWidth: "600px" }}
                  >
                    You are going to explore the list of books available for a
                    Book Club.
                  </div>
                  <div className="fs-4 fw-bold mt-4 text-center">
                    Let’s start!
                  </div>

                  <div
                    className="mx-auto  mt-4"
                    style={{
                      width: "100px",
                      height: "40px",
                      backgroundColor: "#E9E9E9",
                      borderRadius: "10px",
                      color: "#3B3B3B",
                    }}
                  >
                    <Form.Select
                      aria-label="Select Country"
                      className="outline11 custom-select   fw600 fs-5  py-1   coumtrywid ftzcopy "
                      style={{
                        backgroundColor: "#62C0C7",
                        width: "160px",
                        // height: "44px",
                        lineHeight: "40px",
                        color: "#fff",
                        paddingLeft: "30px",
                        cursor: "pointer",
                      }}
                      onChange={handleCountrySelect} // Handle the change event
                    >
                      <option value="">Country</option>
                      {countries.map((country, index) => (
                        <option key={index} value={country}>
                          {country}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>

        <div
          className="d-flex leadhight  justzomag11  leadflex gap-lg-5 gap-1 w-100  text-uppercase"
          style={{ backgroundColor: "#A6A6A6", height: "59px" }}
        >
          <div
            className="px-lg-5 px-md-4 px-3 py-3   bg-white ftzgern text-dark fw-bold fs-18 text-center  "
            style={{ cursor: "pointer" }}
          >
            I’m leading
          </div>

          <div
            className="px-md-3 px-2 pt-3 ftzgern text-dark fw-bold fs-18 text-center"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/dashboarduser")}
          >
            {/* I’M JOINING */}
            {lg?.joining}
          </div>

          <div
            className="px-md-3 px-2 pt-3  ftzgern text-dark fw-bold fs-18 text-center"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/booksandreviewsuser")}
          >
            {/* Books & reviews */}
            {lg?.bandrew}
          </div>

          {user?.isAmbassador && (
            <div
              className="px-md-3 px-sm-2 pt-3 ftzgern text-dark fw-bold fs-18 text-center"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/loyalty")}
            >
              {/* Loyalty programme */}
              {lg?.loyprog}
            </div>
          )}
        </div>
        {user?.isAmbassador && (
          <>
            <div className=" mlmrleading textczoom11 fontupcon fw-bold mt-5 fs-5">
              {/* Upcoming Book Clubs */}
              {lg?.upcomclub}
            </div>

            <div className="d-sm-flex d-none flex-wrap  justzomag11  jucfyy paddleft mx-5 gap-3 mt-3">
              {bookClubBooks?.length === 0 && "No events to be shown."}
              {bookClubBooks.map((book, index) => {
                let spotsLeft =
                  Number(book?.maxAttendee) -
                  Number(book?.attendees?.length || 0);
                return (
                  <Card
                    key={book._id}
                    className="border-0 align-items-center"
                    style={{ width: "" }}
                  >
                    <div className="d-sm-flex gap-2">
                      {book.image ? (
                        <div
                          style={{
                            position: "relative",
                          }}
                        >
                          <Card.Img
                            className="imgsize157"
                            variant="top"
                            src={resolveBookImageUrl(book.image)}
                            style={{
                              width: "119px",
                              height: "170px",
                              objectFit: "contain",
                              cursor: "pointer",
                              opacity:
                                book?.name == "Book Club"
                                  ? spotsLeft === 0
                                    ? 0.3
                                    : 1
                                  : 1,
                            }}
                            onClick={() => {
                              const eventData = {
                                type: book.name,
                                location: book.city || "", // Use dynamic location
                                link: book.link || "",
                                title: book.title,
                                image: book.image,
                                author: book.author,
                                aboutBook: book.aboutBook,
                                pages: book.pageNumber,
                                genre: book.genre,
                                age: book.age,
                                aboutBook: book.aboutBook,

                                city: book.city,
                                language: book.language,
                                gender: book.gender,
                                detail: book.description,
                                eventType: book.type,
                                createdAt: book?.dateInfo,
                                time: book?.timeTrack,
                                userId: book?.userId,
                                link: book.link || "",
                                meetingLink: book?.meetingLink,
                                eventId: book._id,
                                attendees: book?.attendees,
                                LangLat: book?.location,
                                // type:
                                //   book.type.toLowerCase() === "on-line"
                                //     ? "Book Duo"
                                //     : "Book Club", // ✅ Condition Added
                              };
                              console.log("✅ Event Data:", eventData);
                              console.log(
                                "✅ Anttendss Event Data:",
                                book.attendees
                              );
                              console.log(
                                "✅ Anttendss Book Id Event Data:",
                                book._id
                              );

                              localStorage.setItem(
                                "eventDataNew",
                                JSON.stringify(eventData)
                              );
                              handleEventTypeClick(book.name, book._id);
                            }}
                          />
                          {spotsLeft === 0 && book?.name == "Book Club" && (
                            <div
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform:
                                  "translate(-50%, -50%) rotate(301deg)",
                                color: "red",
                                fontSize: "32px",
                                fontWeight: "bold",
                                border: "2px solid red",
                                padding: "5px 15px",
                                textTransform: "uppercase",
                                backgroundColor: "rgba(255,255,255,0.6)",
                                pointerEvents: "none",
                              }}
                            >
                              FULL
                            </div>
                          )}
                        </div>
                      ) : book.name === "Silent Reading" ? (
                        <div
                          style={{
                            position: "relative",
                          }}
                        >
                          {" "}
                          <Card.Img
                            className="imgsize157"
                            variant="top"
                            src={require("./image/book7.jpg")}
                            style={{
                              width: "119px",
                              height: "170px",
                              objectFit: "contain",
                              opacity:
                                book?.name == "Silent Reading"
                                  ? spotsLeft === 0
                                    ? 0.3
                                    : 1
                                  : 1,
                            }}
                            onClick={() => {
                              const eventData = {
                                type: book.name,
                                location: book.city || "", // Use dynamic location
                                link: book.link || "",
                                title: book.title,
                                image: book.image,
                                author: book.author,
                                pages: book.pageNumber,
                                genre: book.genre,
                                aboutBook: book.aboutBook,

                                age: book.age,
                                city: book.city,
                                language: book.language,
                                gender: book.gender,
                                detail: book.description,
                                eventType: book.type,
                                createdAt: book?.dateInfo,
                                time: book?.timeTrack,
                                userId: book?.userId,
                                meetingLink: book?.meetingLink,
                                eventId: book._id,
                                attendees: book?.attendees,
                                LangLat: book?.location,
                              };
                              console.log("✅ Event Data:", eventData);
                              localStorage.setItem(
                                "eventDataNew",
                                JSON.stringify(eventData)
                              );
                              handleEventTypeClick(book.name, book._id);
                            }}
                          />
                          {spotsLeft === 0 &&
                            book?.name == "Silent Reading" && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform:
                                    "translate(-50%, -50%) rotate(301deg)",
                                  color: "red",
                                  fontSize: "32px",
                                  fontWeight: "bold",
                                  border: "2px solid red",
                                  padding: "5px 15px",
                                  textTransform: "uppercase",
                                  backgroundColor: "rgba(255,255,255,0.6)",
                                  pointerEvents: "none",
                                }}
                              >
                                FULL
                              </div>
                            )}
                        </div>
                      ) : (
                        <div
                          style={{
                            width: "119px",
                            height: "170px",
                            backgroundColor: "#e0e0e0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#777",
                          }}
                          onClick={() => {
                            const eventData = {
                              type: book.name,
                              location: book.city || "", // Use dynamic location
                              link: book.link || "",
                              title: book.title,
                              image: book.image,
                              author: book.author,
                              aboutBook: book.aboutBook,

                              pages: book.pageNumber,
                              genre: book.genre,
                              age: book.age,
                              city: book.city,
                              language: book.language,
                              gender: book.gender,
                              detail: book.description,
                              eventType: book.type,
                              createdAt: book?.dateInfo,
                              time: book?.timeTrack,
                              userId: book?.userId,
                              meetingLink: book?.meetingLink,
                              eventId: book._id,
                              attendees: book?.attendees,
                              LangLat: book?.location,
                            };
                            console.log("✅ Event Data:", eventData);

                            localStorage.setItem(
                              "eventDataNew",
                              JSON.stringify(eventData)
                            );
                            handleEventTypeClick(book.name, book._id);
                          }}
                        >
                          No Image
                        </div>
                      )}
                      <Card.Body className="mt-0 pt-0 ">
                        <Card.Title
                          className=" w-100 text-black  fw-bold ftztitle "
                          style={{
                            // color: "#6D6D6D",
                            fontSize: "18px",
                            maxWidth: "210px",

                            lineHeight:
                              book.title[0] === "Before the coffee"
                                ? "20px"
                                : "30px", // Conditional line height

                            marginBottom:
                              book.title[0] === "We Solve Murders with love"
                                ? "5px"
                                : "15px", // Conditional line height
                          }}
                        >
                          {book?.name === "Silent Reading"
                            ? "Your Own Book"
                            : book?.title?.slice(0, 14) || "Normal People"}
                        </Card.Title>
                        <Card.Text
                          className=" w-100 ftzgern fw-bold  m-0"
                          style={{
                            // color: "#383838",
                            color: "gray",
                            fontSize: "16px",
                            lineHeight: "25px",
                            maxWidth: "215px",
                          }}
                        >
                          {book?.name == "Book Duo"
                            ? "TBD"
                            : book?.dateInfo?.dayName +
                              ",  " +
                              book?.dateInfo?.day +
                              " " +
                              book?.dateInfo?.month +
                              " " +
                              book?.dateInfo?.year}
                        </Card.Text>
                        <Card.Title
                          className=" ftzgern fw600 fs-6 m-0"
                          style={{
                            color:
                              book.name === "Book Duo"
                                ? "#C55A11"
                                : book.name === "Book Club"
                                ? "#548235"
                                : book.name === "Silent Reading"
                                ? "#0070C0" // Blue for "Silent Reading"
                                : "#000000", // Default color for other event types

                            lineHeight: "25px",
                          }}
                        >
                          {book?.name}
                        </Card.Title>
                        <Card.Title
                          className=" ftzgern fw600 fs-6 m-0"
                          style={{
                            color: "#000000",

                            lineHeight: "20px",
                          }}
                        >
                          Age: {book?.age}
                        </Card.Title>
                        <div key={book._id}>
                          <Dropdown className="dropclnrt2">
                            <Dropdown.Toggle as="div">
                              <button
                                className="rounded-1 py-1 mt-3 editbtitn fw600 ftzgern fs-6 text-center text-dark"
                                style={{
                                  border: "1px solid #383838",
                                  backgroundColor: "#F2F2F2",
                                  width: "90px",
                                  height: "auto",
                                }}
                                onClick={() => {
                                  const eventData = {
                                    type: book.name,
                                    location: book.city || "", // Use dynamic location
                                    link: book.link || "",
                                    title: book.title,
                                    image: book.image,
                                    author: book.author,
                                    pages: book.pageNumber,
                                    genre: book.genre,
                                    age: book.age,
                                    city: book.city,
                                    language: book.language,
                                    gender: book.gender,
                                    detail: book.description,
                                    eventType: book.type,
                                    createdAt: book?.dateInfo,
                                    time: book?.timeTrack,
                                    userId: book?.userId,
                                    meetingLink: book?.meetingLink,
                                    eventId: book._id,
                                    attendees: book?.attendees,
                                    LangLat: book?.location,
                                    // type:
                                    //   book.type.toLowerCase() === "on-line"
                                    //     ? "Book Duo"
                                    //     : "Book Club", // ✅ Condition Added
                                  };
                                  console.log("MAnhe ID", book);
                                  setGroupChatName(book);
                                  handleEditClick1(book._id);
                                }}
                              >
                                {/* Manage */}
                                {lg?.mang}
                              </button>
                            </Dropdown.Toggle>
                            <div className="pualpicdrop  pualpicdropleadind">
                              <Dropdown.Menu className="py-1 px-1 ">
                                <Dropdown.Item
                                  className=" mt-1 fw600 text-dark"
                                  style={{
                                    fontSize: "14px",
                                    lineHeight: "21.79px",
                                    borderBottom: "2px soild ",
                                  }}
                                  onClick={handleQ6Show}
                                >
                                  {/* Attendees list */}
                                  {lg?.attlist}
                                </Dropdown.Item>

                                <Dropdown.Item
                                  className=" mt-1 fw600 text-dark"
                                  style={{
                                    lineHeight: "21.79px",
                                    fontSize: "14px",
                                  }}
                                  onClick={() => {
                                    navigate(`/booksdetails/${book._id}`);
                                  }}
                                >
                                  {/* Edit event */}
                                  {lg?.edit}
                                </Dropdown.Item>

                                <Dropdown.Item
                                  className=" mt-1 fw600 text-dark"
                                  style={{
                                    lineHeight: "21.79px",
                                    fontSize: "14px",
                                    textTransform: "capitalize",
                                  }}
                                  onClick={() => {
                                    handleShowC(true);
                                  }}
                                >
                                  {/* Edit event */}
                                  {lg?.cancel}
                                </Dropdown.Item>
                                <Modal
                                  show={cShow}
                                  onHide={handleCloseC}
                                  centered
                                  className="custom-gropmodelwel  roundedambdmodl roundedambdmodlcancel"
                                  backdrop={true}
                                >
                                  <Modal.Header className=" border-0">
                                    <img
                                      className=" border-0 closebtnevtn2 top-0 mt-4 mx-4 "
                                      src={require("../components/image/close.png")}
                                      alt="logo"
                                      onClick={handleCloseC}
                                    />
                                  </Modal.Header>
                                  <Modal.Title className="mx-5 "></Modal.Title>
                                  <Modal.Body className="mx-4 mt-sm-2">
                                    <div
                                      className=" fw-bold   text-center  w-100 ftzcopy   "
                                      style={{ fontSize: "21px" }}
                                    >
                                      Are you sure you want to cancel this
                                      event?
                                    </div>

                                    <div
                                      className=" fw-bormal  mt-3 text-center  w-100 ftzcopy   "
                                      style={{ fontSize: "21px" }}
                                    >
                                      A cancellation e-mail will be sent to the
                                      current attendees.
                                    </div>
                                    <div className="d-flex justify-content-center mt-4">
                                      <button
                                        className="text-white subbtnmeet border-0 fs-5 fw600 rounded-2"
                                        style={{
                                          width: "150px",
                                          height: "44px",
                                          backgroundColor: "#62C0C7",
                                          textTransform: "capitalize",
                                        }}
                                        // onClick={handleCloseC}

                                        onClick={() => {
                                          const eventData = {
                                            type: book.name,
                                            location: book.city || "", // Use dynamic location
                                            link: book.link || "",
                                            title: book.title,
                                            image: book.image,
                                            author: book.author,
                                            pages: book.pageNumber,
                                            genre: book.genre,
                                            age: book.age,
                                            city: book.city,
                                            language: book.language,
                                            gender: book.gender,
                                            detail: book.description,
                                            eventType: book.type,
                                            createdAt: book?.dateInfo,
                                            time: book?.timeTrack,
                                            userId: book?.userId,
                                            meetingLink: book?.meetingLink,
                                            eventId: book._id,
                                            attendees: book?.attendees,
                                            LangLat: book?.location,
                                            // type:
                                            //   book.type.toLowerCase() === "on-line"
                                            //     ? "Book Duo"
                                            //     : "Book Club", // ✅ Condition Added
                                          };
                                          handleCancelAttendance(book._id);
                                        }}
                                      >
                                        {lg?.cancel}
                                      </button>
                                    </div>
                                  </Modal.Body>
                                </Modal>
                              </Dropdown.Menu>
                            </div>
                          </Dropdown>

                         

                          {/* Conditional Content */}
                          <div
                            key={index}
                            className={`z-3 d-none mt-2 p-2 oraginwid bg-white position-absolute ${
                              visibleCard1 === index ? "" : "d-none"
                            }`}
                            style={{
                              border: "1px solid #C1C1C1",
                              width: "240px",
                              height: "100px",
                            }}
                          >
                           
                            <div>
                              <Form>
                                {["radio"].map((type) => (
                                  <div
                                    key={`inline-${type}`}
                                    className="fw-normal flxder pt-1"
                                    style={{ fontSize: "14px" }}
                                  >
                                    <Form.Check
                                      inline
                                      label="going"
                                      name={`group-${index}`}
                                      type={type}
                                      id={`inline-${type}-1-${index}`}
                                      onClick={handleGoing1}
                                      checked={selectedGoing[index] === "Going"}
                                      onChange={() =>
                                        handleOptionChangeGoing(index, "Going")
                                      }
                                    />
                                    <Form.Check
                                      inline
                                      label="not going"
                                      name={`group-${index}`}
                                      type={type}
                                      id={`inline-${type}-2-${index}`}
                                      // onClick={handleShowW}
                                      onClick={() => handleShowW(index)} // Open modal for this book

                                      // onChange={() => handleNotGoing(index)}
                                    />
                                  </div>
                                ))}
                              </Form>
                              {wShow === index && (
                                <Modal
                                  show={true}
                                  onHide={handleCloseW}
                                  centered
                                  className="custom-gropmodelwel roundedambdmodl"
                                  backdrop={true}
                                >
                                  <Modal.Header className=" border-0">
                                    <img
                                      className=" border-0 closebtnevtn2 top-0 mt-4 mx-4 "
                                      src={require("../components/image/close.png")}
                                      alt="logo"
                                      onClick={handleCloseW}
                                    />
                                  </Modal.Header>
                                  <Modal.Title className="mx-5 "></Modal.Title>
                                  <Modal.Body className="mx-4 mt-sm-2">
                                    <div
                                      className=" fw-bold   text-center  w-100 ftzcopy   "
                                      style={{ fontSize: "21px" }}
                                    >
                                      Are you sure that you no longer want to
                                      attend this event? The event will be
                                      removed from your dashboard.
                                    </div>
                                    <div className="d-flex justify-content-center mt-4">
                                      <button
                                        className="text-white subbtnmeet border-0 fs-5 fw600 rounded-2"
                                        style={{
                                          width: "150px",
                                          height: "44px",
                                          backgroundColor: "#62C0C7",
                                        }}
                                        onClick={() => handleNotGoing(index)}
                                      >
                                        Not going
                                      </button>
                                    </div>
                                  </Modal.Body>
                                </Modal>
                              )}
                            </div>
                            {/* )} */}
                            <div
                              className="fw600 text-decoration-underline"
                              style={{ fontSize: "13px", cursor: "pointer" }}
                              onClick={handleCancel1}
                            >
                              Cancel
                            </div>
                          </div>
                        </div>
                        
                      </Card.Body>
                    </div>

                 
                  </Card>
                );
              })}
            </div>

            {/* coursol */}
            <div className=" my-4 jucfyy mx-0 d-sm-none d-block  ">
              {bookClubBooks?.length === 0 && "No events to be shown."}
              <Slider {...settings}>
                {bookClubBooks.map((book, index) => {
                  let spotsLeft =
                    Number(book?.maxAttendee) -
                    Number(book?.attendees?.length || 0);

                  return (
                    <div
                      key={book._id}
                      className="d-flex justify-content-center"
                    >
                      <Card
                        key={book._id}
                        className="border-0 align-items-center"
                        style={{ width: "" }}
                      >
                        <div className="d-sm-flex gap-2">
                          {book.image ? (
                            <div
                              style={{
                                position: "relative",
                              }}
                            >
                              <Card.Img
                                className="ss"
                                variant="top"
                                src={resolveBookImageUrl(book.image)}
                                style={{
                                  width: "115px",
                                  height: "150px",
                                  objectFit: "contain",
                                  cursor: "pointer",
                                  opacity:
                                    book?.name == "Book Club"
                                      ? spotsLeft === 0
                                        ? 0.3
                                        : 1
                                      : 1,
                                }}
                                onClick={() => {
                                  const eventData = {
                                    type: book.name,
                                    location: book.city || "", // Use dynamic location
                                    link: book.link || "",
                                    title: book.title,
                                    image: book.image,
                                    author: book.author,
                                    pages: book.pageNumber,
                                    genre: book.genre,
                                    age: book.age,
                                    city: book.city,
                                    language: book.language,
                                    gender: book.gender,
                                    detail: book.description,
                                    eventType: book.type,
                                    createdAt: book?.dateInfo,
                                    time: book?.timeTrack,
                                    userId: book?.userId,
                                    meetingLink: book?.meetingLink,
                                    eventId: book._id,
                                    attendees: book?.attendees,
                                    LangLat: book?.location,
                                    aboutBook: book.aboutBook,

                                    // type:
                                    //   book.type.toLowerCase() === "on-line"
                                    //     ? "Book Duo"
                                    //     : "Book Club", // ✅ Condition Added
                                  };
                                  console.log("✅ Event Data:", eventData);
                                  localStorage.setItem(
                                    "eventDataNew",
                                    JSON.stringify(eventData)
                                  );
                                  handleEventTypeClick(book.name, book._id);
                                }}
                              />
                              {spotsLeft === 0 && book?.name == "Book Club" && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform:
                                      "translate(-50%, -50%) rotate(301deg)",
                                    color: "red",
                                    fontSize: "32px",
                                    fontWeight: "bold",
                                    border: "2px solid red",
                                    padding: "5px 15px",
                                    textTransform: "uppercase",
                                    backgroundColor: "rgba(255,255,255,0.6)",
                                    pointerEvents: "none",
                                  }}
                                >
                                  FULL
                                </div>
                              )}
                            </div>
                          ) : book.name === "Silent Reading" ? (
                            <div
                              style={{
                                position: "relative",
                              }}
                            >
                              <Card.Img
                                className="imgsizsse157"
                                variant="top"
                                src={require("./image/book7.jpg")}
                                style={{
                                  width: "115px",
                                  height: "150px",
                                  objectFit: "contain",
                                  opacity:
                                    book?.name == "Silent Reading"
                                      ? spotsLeft === 0
                                        ? 0.3
                                        : 1
                                      : 1,
                                }}
                                onClick={() => {
                                  const eventData = {
                                    type: book.name,
                                    location: book.city || "", // Use dynamic location
                                    link: book.link || "",
                                    title: book.title,
                                    image: book.image,
                                    author: book.author,
                                    pages: book.pageNumber,
                                    genre: book.genre,
                                    age: book.age,
                                    city: book.city,
                                    language: book.language,
                                    gender: book.gender,
                                    detail: book.description,
                                    eventType: book.type,
                                    createdAt: book?.dateInfo,
                                    time: book?.timeTrack,
                                    userId: book?.userId,
                                    meetingLink: book?.meetingLink,
                                    eventId: book._id,
                                    attendees: book?.attendees,
                                    LangLat: book?.location,
                                    aboutBook: book.aboutBook,

                                    // type:
                                    //   book.type.toLowerCase() === "on-line"
                                    //     ? "Book Duo"
                                    //     : "Book Club", // ✅ Condition Added
                                  };
                                  console.log("✅ Event Data:", eventData);
                                  localStorage.setItem(
                                    "eventDataNew",
                                    JSON.stringify(eventData)
                                  );
                                  handleEventTypeClick(book.name, book._id);
                                }}
                              />
                              {spotsLeft === 0 &&
                                book?.name == "Silent Reading" && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: "50%",
                                      left: "50%",
                                      transform:
                                        "translate(-50%, -50%) rotate(301deg)",
                                      color: "red",
                                      fontSize: "32px",
                                      fontWeight: "bold",
                                      border: "2px solid red",
                                      padding: "5px 15px",
                                      textTransform: "uppercase",
                                      backgroundColor: "rgba(255,255,255,0.6)",
                                      pointerEvents: "none",
                                    }}
                                  >
                                    FULL
                                  </div>
                                )}
                            </div>
                          ) : (
                            <div
                              style={{
                                width: "115px",
                                height: "150px",
                                backgroundColor: "#e0e0e0",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#777",
                              }}
                              onClick={() => {
                                const eventData = {
                                  type: book.name,
                                  location: book.city || "", // Use dynamic location
                                  link: book.link || "",
                                  title: book.title,
                                  image: book.image,
                                  author: book.author,
                                  pages: book.pageNumber,
                                  genre: book.genre,
                                  age: book.age,
                                  city: book.city,
                                  language: book.language,
                                  gender: book.gender,
                                  detail: book.description,
                                  eventType: book.type,
                                  aboutBook: book.aboutBook,

                                  createdAt: book?.dateInfo,
                                  time: book?.timeTrack,
                                  userId: book?.userId,
                                  meetingLink: book?.meetingLink,
                                  eventId: book._id,
                                  attendees: book?.attendees,
                                  LangLat: book?.location,
                                  // type:
                                  //   book.type.toLowerCase() === "on-line"
                                  //     ? "Book Duo"
                                  //     : "Book Club", // ✅ Condition Added
                                };
                                console.log("✅ Event Data:", eventData);
                                localStorage.setItem(
                                  "eventDataNew",
                                  JSON.stringify(eventData)
                                );
                                handleEventTypeClick(book.name, book._id);
                              }}
                            >
                              No Image
                            </div>
                          )}
                          <Card.Body className="mt-0 p-0 text-center">
                            <Card.Title
                              className=" w-100 text-blakkck  fw-bold ftztfitle "
                              style={{
                                // color: "#6D6D6D",
                                fontSize: "15px",
                                maxWidth: "115px",

                                lineHeight:
                                  book.title[0] === "Before the coffee"
                                    ? "20px"
                                    : "25px", // Conditional line height

                                marginBottom:
                                  book.title[0] === "We Solve Murders with love"
                                    ? "5px"
                                    : "5px", // Conditional line height
                              }}
                            >
                              {book?.name === "Silent Reading"
                                ? "Your Own Book"
                                : book?.title?.slice(0, 14) || "Normal People"}
                            </Card.Title>
                            <Card.Text
                              className=" w-100 ftzgegrn fw-bold  m-0"
                              style={{
                                // color: "#383838",
                                color: "gray",
                                fontSize: "14px",
                                lineHeight: "20px",
                                maxWidth: "130px",
                              }}
                            >
                              {book?.name == "Book Duo"
                                ? "TBD"
                                : book?.dateInfo?.dayName +
                                  ",  " +
                                  book?.dateInfo?.day +
                                  " " +
                                  book?.dateInfo?.month +
                                  " " +
                                  book?.dateInfo?.year}
                            </Card.Text>
                            <Card.Title
                              className=" ftzgegrn fw600  m-0"
                              style={{
                                fontSize: "15px",
                                color:
                                  book.name === "Book Duo"
                                    ? "#C55A11"
                                    : book.name === "Book Club"
                                    ? "#548235"
                                    : book.name === "Silent Reading"
                                    ? "#0070C0" // Blue for "Silent Reading"
                                    : "#000000", // Default color for other event types

                                lineHeight: "25px",
                              }}
                            >
                              {book?.name}
                            </Card.Title>
                            <Card.Title
                              className=" ftzggern fw600  m-0"
                              style={{
                                fontSize: "15px",

                                lineHeight: "25px",
                              }}
                            >
                              Age: {book?.age}
                            </Card.Title>
                            <div key={book._id}>
                              <Dropdown className="dropclnrt2">
                                <Dropdown.Toggle as="div">
                                  <button
                                    className="rounded-1 py-1 mt-3 editbtitn fw600 ftzgern fs-6 text-center text-dark"
                                    style={{
                                      border: "1px solid #383838",
                                      backgroundColor: "#F2F2F2",
                                      width: "80px",
                                      height: "auto",
                                    }}
                                    onClick={() => {
                                      const eventData = {
                                        type: book.name,
                                        location: book.city || "", // Use dynamic location
                                        link: book.link || "",
                                        title: book.title,
                                        image: book.image,
                                        author: book.author,
                                        pages: book.pageNumber,
                                        genre: book.genre,
                                        age: book.age,
                                        city: book.city,
                                        language: book.language,
                                        gender: book.gender,
                                        detail: book.description,
                                        eventType: book.type,
                                        createdAt: book?.dateInfo,
                                        time: book?.timeTrack,
                                        userId: book?.userId,
                                        meetingLink: book?.meetingLink,
                                        eventId: book._id,
                                        attendees: book?.attendees,
                                        LangLat: book?.location,
                                        // type:
                                        //   book.type.toLowerCase() === "on-line"
                                        //     ? "Book Duo"
                                        //     : "Book Club", // ✅ Condition Added
                                      };
                                      console.log("MAnhe ID", book._id);
                                      setGroupChatName(book);
                                      handleEditClick1(book._id);
                                    }}
                                  >
                                    {/* Manage */}
                                    {lg?.mang}
                                  </button>
                                </Dropdown.Toggle>
                                <div className="pualpicdrop  pualpicdropleadind">
                                  <Dropdown.Menu className="py-1 px-1 ">
                                    <Dropdown.Item
                                      className=" mt-1 fw600 text-dark"
                                      style={{
                                        lineHeight: "21.79px",
                                        borderBottom: "2px soild ",
                                        fontSize: "14px",
                                      }}
                                      onClick={handleQ6Show}
                                    >
                                      {/* Attendees list */}
                                      {lg?.attlist}
                                    </Dropdown.Item>

                                    <Dropdown.Item
                                      className=" mt-1 fw600 text-dark"
                                      style={{
                                        lineHeight: "21.79px",
                                        fontSize: "14px",
                                      }}
                                      onClick={() => {
                                        const eventData = {
                                          type: book.name,
                                          location: book.city || "", // Use dynamic location
                                          link: book.link || "",
                                          title: book.title,
                                          image: book.image,
                                          author: book.author,
                                          pages: book.pageNumber,
                                          genre: book.genre,
                                          age: book.age,
                                          city: book.city,
                                          language: book.language,
                                          gender: book.gender,
                                          detail: book.description,
                                          eventType: book.type,
                                          createdAt: book?.dateInfo,
                                          time: book?.timeTrack,
                                          userId: book?.userId,
                                          meetingLink: book?.meetingLink,
                                          eventId: book._id,
                                          attendees: book?.attendees,
                                          LangLat: book?.location,
                                          // type:
                                          //   book.type.toLowerCase() === "on-line"
                                          //     ? "Book Duo"
                                          //     : "Book Club", // ✅ Condition Added
                                        };
                                        console.log("Edit bOOk ID", book._id);

                                        navigate(`/booksdetails/${book._id}`);
                                      }}
                                    >
                                      {/* Edit event */}
                                      {lg?.event}
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      className=" mt-1 fw600 text-dark"
                                      style={{
                                        lineHeight: "21.79px",
                                        fontSize: "14px",
                                        textTransform: "capitalize",
                                      }}
                                      onClick={() => {
                                        const eventData = {
                                          type: book.name,
                                          location: book.city || "", // Use dynamic location
                                          link: book.link || "",
                                          title: book.title,
                                          image: book.image,
                                          author: book.author,
                                          pages: book.pageNumber,
                                          genre: book.genre,
                                          age: book.age,
                                          city: book.city,
                                          language: book.language,
                                          gender: book.gender,
                                          detail: book.description,
                                          eventType: book.type,
                                          createdAt: book?.dateInfo,
                                          time: book?.timeTrack,
                                          userId: book?.userId,
                                          meetingLink: book?.meetingLink,
                                          eventId: book._id,
                                          attendees: book?.attendees,
                                          LangLat: book?.location,
                                          // type:
                                          //   book.type.toLowerCase() === "on-line"
                                          //     ? "Book Duo"
                                          //     : "Book Club", // ✅ Condition Added
                                        };
                                        handleShowC(true);
                                      }}
                                    >
                                      {/* Edit event */}
                                      {lg?.cancel}
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </div>
                              </Dropdown>
                            </div>
                          </Card.Body>
                        </div>
                      </Card>
                    </div>
                  );
                })}
              </Slider>
            </div>
          </>
        )}
        <div className=" mlmrleading textczoom11 fontupcon fw-bold mt-5 fs-5">
          {/* Upcoming Book Duo */}
          {lg?.upcomduo}
        </div>

        <div className="d-sm-flex d-none flex-wrap  justzomag11  jucfyy paddleft mx-5 gap-3 mt-3">
          {bookDuoBooks?.length === 0 && "No events to be shown."}
          {bookDuoBooks.map((book, index) => (
            <Card
              key={book._id}
              className="border-0 align-items-center"
              style={{ width: "" }}
            >
              <div className="d-sm-flex gap-2">
                {book.image ? (
                  <Card.Img
                    className="imgsize157"
                    variant="top"
                    src={resolveBookImageUrl(book.image)}
                    style={{
                      width: "119px",
                      height: "170px",
                      objectFit: "contain",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      const eventData = {
                        type: book.name,
                        location: book.city || "", // Use dynamic location
                        link: book.link || "",
                        title: book.title,
                        image: book.image,
                        author: book.author,
                        aboutBook: book.aboutBook,
                        pages: book.pageNumber,
                        genre: book.genre,
                        age: book.age,
                        aboutBook: book.aboutBook,

                        city: book.city,
                        language: book.language,
                        gender: book.gender,
                        detail: book.description,
                        eventType: book.type,
                        createdAt: book?.dateInfo,
                        time: book?.timeTrack,
                        userId: book?.userId,
                        link: book.link || "",
                        meetingLink: book?.meetingLink,
                        eventId: book._id,
                        attendees: book?.attendees,
                        LangLat: book?.location,
                      };
                      localStorage.setItem(
                        "eventDataNew",
                        JSON.stringify(eventData)
                      );
                      handleEventTypeClick(book.name, book._id);
                    }}
                  />
                ) : book.name === "Silent Reading" ? (
                  <Card.Img
                    className="imgsize157"
                    variant="top"
                    src={require("./image/book7.jpg")}
                    style={{
                      width: "119px",
                      height: "170px",
                      objectFit: "contain",
                    }}
                    onClick={() => {
                      const eventData = {
                        type: book.name,
                        location: book.city || "", // Use dynamic location
                        link: book.link || "",
                        title: book.title,
                        image: book.image,
                        author: book.author,
                        pages: book.pageNumber,
                        genre: book.genre,
                        aboutBook: book.aboutBook,

                        age: book.age,
                        city: book.city,
                        language: book.language,
                        gender: book.gender,
                        detail: book.description,
                        eventType: book.type,
                        createdAt: book?.dateInfo,
                        time: book?.timeTrack,
                        userId: book?.userId,
                        meetingLink: book?.meetingLink,
                        eventId: book._id,
                        attendees: book?.attendees,
                        LangLat: book?.location,
                      };
                      console.log("✅ Event Data:", eventData);
                      localStorage.setItem(
                        "eventDataNew",
                        JSON.stringify(eventData)
                      );
                      handleEventTypeClick(book.name, book._id);
                    }}
                  />
                ) : (
                  <div
                    style={{
                      width: "119px",
                      height: "170px",
                      backgroundColor: "#e0e0e0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#777",
                    }}
                    onClick={() => {
                      const eventData = {
                        type: book.name,
                        location: book.city || "", // Use dynamic location
                        link: book.link || "",
                        title: book.title,
                        image: book.image,
                        author: book.author,
                        aboutBook: book.aboutBook,

                        pages: book.pageNumber,
                        genre: book.genre,
                        age: book.age,
                        city: book.city,
                        language: book.language,
                        gender: book.gender,
                        detail: book.description,
                        eventType: book.type,
                        createdAt: book?.dateInfo,
                        time: book?.timeTrack,
                        userId: book?.userId,
                        meetingLink: book?.meetingLink,
                        eventId: book._id,
                        attendees: book?.attendees,
                        LangLat: book?.location,
                      };
                      console.log("✅ Event Data:", eventData);

                      localStorage.setItem(
                        "eventDataNew",
                        JSON.stringify(eventData)
                      );
                      handleEventTypeClick(book.name, book._id);
                    }}
                  >
                    No Image
                  </div>
                )}
                <Card.Body className="mt-0 pt-0 ">
                  <Card.Title
                    className=" w-100 text-black  fw-bold ftztitle "
                    style={{
                      // color: "#6D6D6D",
                      fontSize: "18px",
                      maxWidth: "210px",

                      lineHeight:
                        book.title[0] === "Before the coffee" ? "20px" : "30px", // Conditional line height

                      marginBottom:
                        book.title[0] === "We Solve Murders with love"
                          ? "5px"
                          : "15px", // Conditional line height
                    }}
                  >
                    {book?.name === "Silent Reading"
                      ? "Your Own Book"
                      : book?.title?.slice(0, 14) || "Normal People"}
                  </Card.Title>
                  <Card.Text
                    className=" w-100 ftzgern fw-bold  m-0"
                    style={{
                      // color: "#383838",
                      color: "gray",
                      fontSize: "16px",
                      lineHeight: "25px",
                      maxWidth: "215px",
                    }}
                  >
                    {book?.name == "Book Duo"
                      ? "TBD"
                      : book?.dateInfo?.dayName +
                        ",  " +
                        book?.dateInfo?.day +
                        " " +
                        book?.dateInfo?.month +
                        " " +
                        book?.dateInfo?.year}
                  </Card.Text>
                  <Card.Title
                    className=" ftzgern fw600 fs-6 m-0"
                    style={{
                      color:
                        book.name === "Book Duo"
                          ? "#C55A11"
                          : book.name === "Book Club"
                          ? "#548235"
                          : book.name === "Silent Reading"
                          ? "#0070C0" // Blue for "Silent Reading"
                          : "#000000", // Default color for other event types

                      lineHeight: "25px",
                    }}
                  >
                    {book?.name}
                  </Card.Title>
                  <Card.Title
                    className=" ftzgern fw600 fs-6 m-0"
                    style={{
                      color: "#000000",

                      lineHeight: "20px",
                    }}
                  >
                    Age: {book?.age}
                  </Card.Title>
                  <div key={book._id}>
                    <Dropdown className="dropclnrt2">
                      <Dropdown.Toggle as="div">
                        <button
                          className="rounded-1 py-1 mt-3 editbtitn fw600 ftzgern fs-6 text-center text-dark"
                          style={{
                            border: "1px solid #383838",
                            backgroundColor: "#F2F2F2",
                            width: "90px",
                            height: "auto",
                          }}
                          onClick={() => {
                            const eventData = {
                              type: book.name,
                              location: book.city || "", // Use dynamic location
                              link: book.link || "",
                              title: book.title,
                              image: book.image,
                              author: book.author,
                              pages: book.pageNumber,
                              genre: book.genre,
                              age: book.age,
                              city: book.city,
                              language: book.language,
                              gender: book.gender,
                              detail: book.description,
                              eventType: book.type,
                              createdAt: book?.dateInfo,
                              time: book?.timeTrack,
                              userId: book?.userId,
                              meetingLink: book?.meetingLink,
                              eventId: book._id,
                              attendees: book?.attendees,
                              LangLat: book?.location,
                            };
                            console.log("MAnhe ID", book._id);
                            setGroupChatName(book);
                            handleEditClick1(book._id);
                          }}
                        >
                          {/* Manage */}
                          {lg?.mang}
                        </button>
                      </Dropdown.Toggle>
                      <div className="pualpicdrop  pualpicdropleadind">
                        <Dropdown.Menu className="py-1 px-1 ">
                          <Dropdown.Item
                            className=" mt-1 fw600 text-dark"
                            style={{
                              fontSize: "14px",
                              lineHeight: "21.79px",
                              borderBottom: "2px soild ",
                            }}
                            onClick={handleQ6Show}
                          >
                            {/* Attendees list */}
                            {lg?.attlist}
                          </Dropdown.Item>

                          <Dropdown.Item
                            className=" mt-1 fw600 text-dark"
                            style={{ lineHeight: "21.79px", fontSize: "14px" }}
                            onClick={() => {
                              navigate(`/createmeetup/${book._id}`);
                            }}
                          >
                            {/* Edit event */}
                            {lg?.edit}
                          </Dropdown.Item>

                          <Dropdown.Item
                            className=" mt-1 fw600 text-dark"
                            style={{
                              lineHeight: "21.79px",
                              fontSize: "14px",
                              textTransform: "capitalize",
                            }}
                            onClick={() => {
                              handleShowC(true);
                            }}
                          >
                            {/* Edit event */}
                            {lg?.cancel}
                          </Dropdown.Item>
                          <Modal
                            show={cShow}
                            onHide={handleCloseC}
                            centered
                            className="custom-gropmodelwel  roundedambdmodl roundedambdmodlcancel"
                            backdrop={true}
                          >
                            <Modal.Header className=" border-0">
                              <img
                                className=" border-0 closebtnevtn2 top-0 mt-4 mx-4 "
                                src={require("../components/image/close.png")}
                                alt="logo"
                                onClick={handleCloseC}
                              />
                            </Modal.Header>
                            <Modal.Title className="mx-5 "></Modal.Title>
                            <Modal.Body className="mx-4 mt-sm-2">
                              <div
                                className=" fw-bold   text-center  w-100 ftzcopy   "
                                style={{ fontSize: "21px" }}
                              >
                                Are you sure you want to cancel this event?
                              </div>

                              <div
                                className=" fw-bormal  mt-3 text-center  w-100 ftzcopy   "
                                style={{ fontSize: "21px" }}
                              >
                                A cancellation e-mail will be sent to the
                                current attendees.
                              </div>
                              <div className="d-flex justify-content-center mt-4">
                                <button
                                  className="text-white subbtnmeet border-0 fs-5 fw600 rounded-2"
                                  style={{
                                    width: "150px",
                                    height: "44px",
                                    backgroundColor: "#62C0C7",
                                    textTransform: "capitalize",
                                  }}
                                  // onClick={handleCloseC}

                                  onClick={() => {
                                    handleCancelAttendance(book._id);
                                  }}
                                >
                                  {lg?.cancel}
                                </button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </Dropdown.Menu>
                      </div>
                    </Dropdown>

                    {/* Conditional Content */}
                    <div
                      key={index}
                      className={`z-3 d-none mt-2 p-2 oraginwid bg-white position-absolute ${
                        visibleCard1 === index ? "" : "d-none"
                      }`}
                      style={{
                        border: "1px solid #C1C1C1",
                        width: "240px",
                        height: "100px",
                      }}
                    >
                      <div>
                        <Form>
                          {["radio"].map((type) => (
                            <div
                              key={`inline-${type}`}
                              className="fw-normal flxder pt-1"
                              style={{ fontSize: "14px" }}
                            >
                              <Form.Check
                                inline
                                label="going"
                                name={`group-${index}`}
                                type={type}
                                id={`inline-${type}-1-${index}`}
                                onClick={handleGoing1}
                                checked={selectedGoing[index] === "Going"}
                                onChange={() =>
                                  handleOptionChangeGoing(index, "Going")
                                }
                              />
                              <Form.Check
                                inline
                                label="not going"
                                name={`group-${index}`}
                                type={type}
                                id={`inline-${type}-2-${index}`}
                                // onClick={handleShowW}
                                onClick={() => handleShowW(index)} // Open modal for this book

                                // onChange={() => handleNotGoing(index)}
                              />
                            </div>
                          ))}
                        </Form>
                        {wShow === index && (
                          <Modal
                            show={true}
                            onHide={handleCloseW}
                            centered
                            className="custom-gropmodelwel roundedambdmodl"
                            backdrop={true}
                          >
                            <Modal.Header className=" border-0">
                              <img
                                className=" border-0 closebtnevtn2 top-0 mt-4 mx-4 "
                                src={require("../components/image/close.png")}
                                alt="logo"
                                onClick={handleCloseW}
                              />
                            </Modal.Header>
                            <Modal.Title className="mx-5 "></Modal.Title>
                            <Modal.Body className="mx-4 mt-sm-2">
                              <div
                                className=" fw-bold   text-center  w-100 ftzcopy   "
                                style={{ fontSize: "21px" }}
                              >
                                Are you sure that you no longer want to attend
                                this event? The event will be removed from your
                                dashboard.
                              </div>
                              <div className="d-flex justify-content-center mt-4">
                                <button
                                  className="text-white subbtnmeet border-0 fs-5 fw600 rounded-2"
                                  style={{
                                    width: "150px",
                                    height: "44px",
                                    backgroundColor: "#62C0C7",
                                  }}
                                  onClick={() => handleNotGoing(index)}
                                >
                                  Not going
                                </button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        )}
                      </div>
                      {/* )} */}
                      <div
                        className="fw600 text-decoration-underline"
                        style={{ fontSize: "13px", cursor: "pointer" }}
                        onClick={handleCancel1}
                      >
                        Cancel
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </div>
            </Card>
          ))}
        </div>

        {/* coursol */}
        <div className=" my-4 jucfyy mx-0 d-sm-none d-block  ">
          {bookDuoBooks?.length === 0 && "No events to be shown."}
          <Slider {...settings}>
            {bookDuoBooks.map((book, index) => (
              <div key={book._id} className="d-flex justify-content-center">
                <Card
                  key={book._id}
                  className="border-0 align-items-center"
                  style={{ width: "" }}
                >
                  <div className="d-sm-flex gap-2">
                    {book.image ? (
                      <Card.Img
                        className="ss"
                        variant="top"
                        src={resolveBookImageUrl(book.image)}
                        style={{
                          width: "115px",
                          height: "150px",
                          objectFit: "contain",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          const eventData = {
                            type: book.name,
                            location: book.city || "", // Use dynamic location
                            link: book.link || "",
                            title: book.title,
                            image: book.image,
                            author: book.author,
                            pages: book.pageNumber,
                            genre: book.genre,
                            age: book.age,
                            city: book.city,
                            language: book.language,
                            gender: book.gender,
                            detail: book.description,
                            eventType: book.type,
                            createdAt: book?.dateInfo,
                            time: book?.timeTrack,
                            userId: book?.userId,
                            meetingLink: book?.meetingLink,
                            eventId: book._id,
                            attendees: book?.attendees,
                            LangLat: book?.location,
                            aboutBook: book.aboutBook,

                            // type:
                            //   book.type.toLowerCase() === "on-line"
                            //     ? "Book Duo"
                            //     : "Book Club", // ✅ Condition Added
                          };
                          console.log("✅ Event Data:", eventData);
                          localStorage.setItem(
                            "eventDataNew",
                            JSON.stringify(eventData)
                          );
                          handleEventTypeClick(book.name, book._id);
                        }}
                      />
                    ) : book.name === "Silent Reading" ? (
                      <Card.Img
                        className="imgsizsse157"
                        variant="top"
                        src={require("./image/book7.jpg")}
                        style={{
                          width: "115px",
                          height: "150px",
                          objectFit: "contain",
                        }}
                        onClick={() => {
                          const eventData = {
                            type: book.name,
                            location: book.city || "", // Use dynamic location
                            link: book.link || "",
                            title: book.title,
                            image: book.image,
                            author: book.author,
                            pages: book.pageNumber,
                            genre: book.genre,
                            age: book.age,
                            city: book.city,
                            language: book.language,
                            gender: book.gender,
                            detail: book.description,
                            eventType: book.type,
                            createdAt: book?.dateInfo,
                            time: book?.timeTrack,
                            userId: book?.userId,
                            meetingLink: book?.meetingLink,
                            eventId: book._id,
                            attendees: book?.attendees,
                            LangLat: book?.location,
                            aboutBook: book.aboutBook,

                            // type:
                            //   book.type.toLowerCase() === "on-line"
                            //     ? "Book Duo"
                            //     : "Book Club", // ✅ Condition Added
                          };
                          console.log("✅ Event Data:", eventData);
                          localStorage.setItem(
                            "eventDataNew",
                            JSON.stringify(eventData)
                          );
                          handleEventTypeClick(book.name, book._id);
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          width: "115px",
                          height: "150px",
                          backgroundColor: "#e0e0e0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#777",
                        }}
                        onClick={() => {
                          const eventData = {
                            type: book.name,
                            location: book.city || "", // Use dynamic location
                            link: book.link || "",
                            title: book.title,
                            image: book.image,
                            author: book.author,
                            pages: book.pageNumber,
                            genre: book.genre,
                            age: book.age,
                            city: book.city,
                            language: book.language,
                            gender: book.gender,
                            detail: book.description,
                            eventType: book.type,
                            aboutBook: book.aboutBook,

                            createdAt: book?.dateInfo,
                            time: book?.timeTrack,
                            userId: book?.userId,
                            meetingLink: book?.meetingLink,
                            eventId: book._id,
                            attendees: book?.attendees,
                            LangLat: book?.location,
                            // type:
                            //   book.type.toLowerCase() === "on-line"
                            //     ? "Book Duo"
                            //     : "Book Club", // ✅ Condition Added
                          };
                          console.log("✅ Event Data:", eventData);
                          localStorage.setItem(
                            "eventDataNew",
                            JSON.stringify(eventData)
                          );
                          handleEventTypeClick(book.name, book._id);
                        }}
                      >
                        No Image
                      </div>
                    )}
                    <Card.Body className="mt-0 p-0 text-center">
                      <Card.Title
                        className=" w-100 text-blakkck  fw-bold ftztfitle "
                        style={{
                          // color: "#6D6D6D",
                          fontSize: "15px",
                          maxWidth: "115px",

                          lineHeight:
                            book.title[0] === "Before the coffee"
                              ? "20px"
                              : "25px", // Conditional line height

                          marginBottom:
                            book.title[0] === "We Solve Murders with love"
                              ? "5px"
                              : "5px", // Conditional line height
                        }}
                      >
                        {book?.name === "Silent Reading"
                          ? "Your Own Book"
                          : book?.title?.slice(0, 14) || "Normal People"}
                      </Card.Title>
                      <Card.Text
                        className=" w-100 ftzgegrn fw-bold  m-0"
                        style={{
                          // color: "#383838",
                          color: "gray",
                          fontSize: "14px",
                          lineHeight: "20px",
                          maxWidth: "130px",
                        }}
                      >
                        {book?.name == "Book Duo"
                          ? "TBD"
                          : book?.dateInfo?.dayName +
                            ",  " +
                            book?.dateInfo?.day +
                            " " +
                            book?.dateInfo?.month +
                            " " +
                            book?.dateInfo?.year}
                      </Card.Text>
                      <Card.Title
                        className=" ftzgegrn fw600  m-0"
                        style={{
                          fontSize: "15px",
                          color:
                            book.name === "Book Duo"
                              ? "#C55A11"
                              : book.name === "Book Club"
                              ? "#548235"
                              : book.name === "Silent Reading"
                              ? "#0070C0" // Blue for "Silent Reading"
                              : "#000000", // Default color for other event types

                          lineHeight: "25px",
                        }}
                      >
                        {book?.name}
                      </Card.Title>
                      <Card.Title
                        className=" ftzggern fw600  m-0"
                        style={{
                          fontSize: "15px",

                          lineHeight: "25px",
                        }}
                      >
                        Age: {book?.age}
                      </Card.Title>
                      <div key={book._id}>
                        <Dropdown className="dropclnrt2">
                          <Dropdown.Toggle as="div">
                            <button
                              className="rounded-1 py-1 mt-3 editbtitn fw600 ftzgern fs-6 text-center text-dark"
                              style={{
                                border: "1px solid #383838",
                                backgroundColor: "#F2F2F2",
                                width: "80px",
                                height: "auto",
                              }}
                              onClick={() => {
                                setGroupChatName(book);
                                handleEditClick1(book._id);
                              }}
                            >
                              {/* Manage */}
                              {lg?.mang}
                            </button>
                          </Dropdown.Toggle>
                          <div className="pualpicdrop  pualpicdropleadind">
                            <Dropdown.Menu className="py-1 px-1 ">
                              <Dropdown.Item
                                className=" mt-1 fw600 text-dark"
                                style={{
                                  lineHeight: "21.79px",
                                  borderBottom: "2px soild ",
                                  fontSize: "14px",
                                }}
                                onClick={handleQ6Show}
                              >
                                {/* Attendees list */}
                                {lg?.attlist}
                              </Dropdown.Item>

                              <Dropdown.Item
                                className=" mt-1 fw600 text-dark"
                                style={{
                                  lineHeight: "21.79px",
                                  fontSize: "14px",
                                }}
                                onClick={() => {
                                  const eventData = {
                                    type: book.name,
                                    location: book.city || "", // Use dynamic location
                                    link: book.link || "",
                                    title: book.title,
                                    image: book.image,
                                    author: book.author,
                                    pages: book.pageNumber,
                                    genre: book.genre,
                                    age: book.age,
                                    city: book.city,
                                    language: book.language,
                                    gender: book.gender,
                                    detail: book.description,
                                    eventType: book.type,
                                    createdAt: book?.dateInfo,
                                    time: book?.timeTrack,
                                    userId: book?.userId,
                                    meetingLink: book?.meetingLink,
                                    eventId: book._id,
                                    attendees: book?.attendees,
                                    LangLat: book?.location,
                                  };
                                  console.log("Edit bOOk ID", book._id);

                                  navigate(`/booksdetails/${book._id}`);
                                }}
                              >
                                {/* Edit event */}
                                {lg?.edit}
                              </Dropdown.Item>
                              <Dropdown.Item
                                className=" mt-1 fw600 text-dark"
                                style={{
                                  lineHeight: "21.79px",
                                  fontSize: "14px",
                                  textTransform: "capitalize",
                                }}
                                onClick={() => {
                                  handleShowC(true);
                                }}
                              >
                                {/* Edit event */}
                                {lg?.cancel}
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </div>
                        </Dropdown>
                      </div>
                    </Card.Body>
                  </div>
                </Card>
              </div>
            ))}
          </Slider>
        </div>
        {user?.isAmbassador && (
          <>
            <div className=" mlmrleading textczoom11 fontupcon fw-bold mt-5 fs-5">
              {/* Upcoming Silent Readings */}
              {lg?.upcomsil}
            </div>

            <div className="d-sm-flex d-none flex-wrap  justzomag11  jucfyy paddleft  mx-5 gap-3 mt-3">
              {booksilentBooks?.length === 0 && "No events to be shown."}
              {booksilentBooks.map((book, index) => {
                let spotsLeft =
                  Number(book?.maxAttendee) -
                  Number(book?.attendees?.length || 0);

                return (
                  <Card
                    key={book._id}
                    className="border-0 align-items-center"
                    style={{ width: "" }}
                  >
                    <div className="d-sm-flex gap-2">
                      {book.image ? (
                        <div
                          style={{
                            position: "relative",
                          }}
                        >
                          {" "}
                          <Card.Img
                            className="imgsize157"
                            variant="top"
                            src={resolveBookImageUrl(book.image)}
                            style={{
                              width: "119px",
                              height: "170px",
                              objectFit: "contain",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              const eventData = {
                                type: book.name,
                                location: book.city || "", // Use dynamic location
                                link: book.link || "",
                                title: book.title,
                                image: book.image,
                                author: book.author,
                                pages: book.pageNumber,
                                genre: book.genre,
                                age: book.age,
                                city: book.city,
                                language: book.language,
                                gender: book.gender,
                                detail: book.description,
                                eventType: book.type,
                                createdAt: book?.dateInfo,
                                time: book?.timeTrack,
                                userId: book?.userId,
                                meetingLink: book?.meetingLink,
                                eventId: book._id,
                                aboutBook: book.aboutBook,

                                attendees: book?.attendees,
                                LangLat: book?.location,
                                // type:
                                //   book.type.toLowerCase() === "on-line"
                                //     ? "Book Duo"
                                //     : "Book Club", // ✅ Condition Added
                              };
                              console.log("✅ Event Data:", eventData);
                              console.log(
                                "✅ Anttendss Event Data:",
                                book.attendees
                              );
                              localStorage.setItem(
                                "eventDataNew",
                                JSON.stringify(eventData)
                              );
                              handleEventTypeClick(book.name, book._id);
                            }}
                          />
                          {spotsLeft === 0 && book?.name == "Book Club" && (
                            <div
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform:
                                  "translate(-50%, -50%) rotate(301deg)",
                                color: "red",
                                fontSize: "32px",
                                fontWeight: "bold",
                                border: "2px solid red",
                                padding: "5px 15px",
                                textTransform: "uppercase",
                                backgroundColor: "rgba(255,255,255,0.6)",
                                pointerEvents: "none",
                              }}
                            >
                              FULL
                            </div>
                          )}
                        </div>
                      ) : book.name === "Silent Reading" ? (
                        <div
                          style={{
                            position: "relative",
                          }}
                        >
                          <Card.Img
                            className="imgsize157"
                            variant="top"
                            src={require("./image/book7.jpg")}
                            style={{
                              width: "119px",
                              height: "170px",
                              objectFit: "contain",
                              cursor: "pointer",
                              opacity:
                                book?.name == "Silent Reading"
                                  ? spotsLeft === 0
                                    ? 0.3
                                    : 1
                                  : 1,
                            }}
                            onClick={() => {
                              const eventData = {
                                type: book.name,
                                location: book.city || "", // Use dynamic location
                                link: book.link || "",
                                title: book.title,
                                image: book.image,
                                author: book.author,
                                pages: book.pageNumber,
                                genre: book.genre,
                                age: book.age,
                                city: book.city,
                                language: book.language,
                                gender: book.gender,
                                detail: book.description,
                                eventType: book.type,
                                createdAt: book?.dateInfo,
                                time: book?.timeTrack,
                                aboutBook: book.aboutBook,

                                userId: book?.userId,
                                meetingLink: book?.meetingLink,
                                eventId: book._id,
                                attendees: book?.attendees,
                                LangLat: book?.location,
                                // type:
                                //   book.type.toLowerCase() === "on-line"
                                //     ? "Book Duo"
                                //     : "Book Club", // ✅ Condition Added
                              };
                              console.log("✅ Event Data:", eventData);
                              console.log(
                                "✅ Anttendss Event Data:",
                                book.attendees
                              );
                              localStorage.setItem(
                                "eventDataNew",
                                JSON.stringify(eventData)
                              );
                              handleEventTypeClick(book.name, book._id);
                            }}
                          />
                          {spotsLeft === 0 &&
                            book?.name == "Silent Reading" && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform:
                                    "translate(-50%, -50%) rotate(301deg)",
                                  color: "red",
                                  fontSize: "32px",
                                  fontWeight: "bold",
                                  border: "2px solid red",
                                  padding: "5px 15px",
                                  textTransform: "uppercase",
                                  backgroundColor: "rgba(255,255,255,0.6)",
                                  pointerEvents: "none",
                                }}
                              >
                                FULL
                              </div>
                            )}
                        </div>
                      ) : (
                        <div
                          style={{
                            width: "119px",
                            height: "170px",
                            backgroundColor: "#e0e0e0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#777",
                          }}
                          onClick={() => {
                            const eventData = {
                              type: book.name,
                              location: book.city || "", // Use dynamic location
                              link: book.link || "",
                              title: book.title,
                              image: book.image,
                              author: book.author,
                              pages: book.pageNumber,
                              genre: book.genre,
                              age: book.age,
                              city: book.city,
                              language: book.language,
                              aboutBook: book.aboutBook,

                              gender: book.gender,
                              detail: book.description,
                              eventType: book.type,
                              createdAt: book?.dateInfo,
                              time: book?.timeTrack,
                              userId: book?.userId,
                              meetingLink: book?.meetingLink,
                              eventId: book._id,
                              attendees: book?.attendees,
                              LangLat: book?.location,
                              // type:
                              //   book.type.toLowerCase() === "on-line"
                              //     ? "Book Duo"
                              //     : "Book Club", // ✅ Condition Added
                            };
                            console.log("✅ Event Data:", eventData);
                            console.log(
                              "✅ Anttendss Event Data:",
                              book.attendees
                            );
                            localStorage.setItem(
                              "eventDataNew",
                              JSON.stringify(eventData)
                            );
                            handleEventTypeClick(book.name, book._id);
                          }}
                        >
                          No Image
                        </div>
                      )}
                      <Card.Body className="mt-0 pt-0 ">
                        <Card.Title
                          className=" w-100 text-black  fw-bold ftztitle "
                          style={{
                            // color: "#6D6D6D",
                            fontSize: "18px",
                            maxWidth: "210px",

                            lineHeight:
                              book.title[0] === "Before the coffee"
                                ? "20px"
                                : "30px", // Conditional line height

                            marginBottom:
                              book.title[0] === "We Solve Murders with love"
                                ? "5px"
                                : "15px", // Conditional line height
                          }}
                        >
                          {book?.name === "Silent Reading"
                            ? "Your Own Book"
                            : book?.title?.slice(0, 14) || "Normal People"}
                        </Card.Title>
                        <Card.Text
                          className=" w-100 ftzgern fw-bold  m-0"
                          style={{
                            // color: "#383838",
                            color: "gray",
                            fontSize: "16px",
                            lineHeight: "25px",
                            maxWidth: "215px",
                          }}
                        >
                          {book?.name == "Book Duo"
                            ? "TBD"
                            : book?.dateInfo?.dayName +
                              ",  " +
                              book?.dateInfo?.day +
                              " " +
                              book?.dateInfo?.month +
                              " " +
                              book?.dateInfo?.year}
                          {/* " " +
                        book?.timeTrack?.minutes +
                        " " +
                        book?.timeTrack?.seconds
                        
                         */}
                        </Card.Text>
                        <Card.Title
                          className=" ftzgern fw600 fs-6 m-0"
                          style={{
                            color:
                              book.name === "Book Duo"
                                ? "#C55A11"
                                : book.name === "Book Club"
                                ? "#548235"
                                : book.name === "Silent Reading"
                                ? "#0070C0" // Blue for "Silent Reading"
                                : "#000000", // Default color for other event types

                            lineHeight: "25px",
                          }}
                        >
                          {book?.name}
                        </Card.Title>
                        <Card.Title
                          className=" ftzgern fw600 fs-6 m-0"
                          style={{
                            color: "#000000",

                            lineHeight: "20px",
                          }}
                        >
                          Age: {book?.age}
                        </Card.Title>
                        <div key={book._id}>
                          <Dropdown className="dropclnrt2">
                            <Dropdown.Toggle as="div">
                              <button
                                className="rounded-1 py-1 mt-3 editbtitn fw600 ftzgern fs-6 text-center text-dark"
                                style={{
                                  border: "1px solid #383838",
                                  backgroundColor: "#F2F2F2",
                                  width: "90px",
                                  height: "auto",
                                }}
                                onClick={() => {
                                  const eventData = {
                                    type: book.name,
                                    location: book.city || "", // Use dynamic location
                                    link: book.link || "",
                                    title: book.title,
                                    image: book.image,
                                    author: book.author,
                                    pages: book.pageNumber,
                                    genre: book.genre,
                                    age: book.age,
                                    city: book.city,
                                    language: book.language,
                                    gender: book.gender,
                                    detail: book.description,
                                    eventType: book.type,
                                    createdAt: book?.dateInfo,
                                    time: book?.timeTrack,
                                    userId: book?.userId,
                                    meetingLink: book?.meetingLink,
                                    eventId: book._id,
                                    attendees: book?.attendees,
                                    LangLat: book?.location,
                                    // type:
                                    //   book.type.toLowerCase() === "on-line"
                                    //     ? "Book Duo"
                                    //     : "Book Club", // ✅ Condition Added
                                  };
                                  console.log("MAnhe ID", book._id);
                                  setGroupChatName(book);
                                  handleEditClick1(book._id);
                                }}
                              >
                                {/* Manage */}
                                {lg?.mang}
                              </button>
                            </Dropdown.Toggle>
                            <div className="pualpicdrop  pualpicdropleadind">
                              <Dropdown.Menu className="py-1 px-1 ">
                                <Dropdown.Item
                                  className=" mt-1 fw600 text-dark"
                                  style={{
                                    fontSize: "14px",
                                    lineHeight: "21.79px",
                                    borderBottom: "2px soild ",
                                  }}
                                  onClick={handleQ6Show}
                                >
                                  {/* Attendees list */}
                                  {lg?.attlist}
                                </Dropdown.Item>

                                <Dropdown.Item
                                  className=" mt-1 fw600 text-dark"
                                  style={{
                                    lineHeight: "21.79px",
                                    fontSize: "14px",
                                  }}
                                  onClick={() => {
                                    const eventData = {
                                      type: book.name,
                                      location: book.city || "", // Use dynamic location
                                      link: book.link || "",
                                      title: book.title,
                                      image: book.image,
                                      author: book.author,
                                      pages: book.pageNumber,
                                      genre: book.genre,
                                      age: book.age,
                                      city: book.city,
                                      language: book.language,
                                      gender: book.gender,
                                      detail: book.description,
                                      eventType: book.type,
                                      createdAt: book?.dateInfo,
                                      time: book?.timeTrack,
                                      userId: book?.userId,
                                      meetingLink: book?.meetingLink,
                                      eventId: book._id,
                                      attendees: book?.attendees,
                                      LangLat: book?.location,
                                      // type:
                                      //   book.type.toLowerCase() === "on-line"
                                      //     ? "Book Duo"
                                      //     : "Book Club", // ✅ Condition Added
                                    };
                                    console.log("Edit bOOk ID", book._id);

                                    navigate(`/silentReading/${book._id}`);
                                  }}
                                >
                                  {/* Edit event */}
                                  {lg?.edit}
                                </Dropdown.Item>
                                <Dropdown.Item
                                  className=" mt-1 fw600 text-dark"
                                  style={{
                                    lineHeight: "21.79px",
                                    fontSize: "14px",
                                    textTransform: "capitalize",
                                  }}
                                  onClick={() => {
                                    handleShowC(true);
                                    // handleCancelAttendance(book.id);
                                  }}
                                >
                                  {/* Edit event */}
                                  {lg?.cancel}
                                </Dropdown.Item>
                                <Modal
                                  show={cShow}
                                  onHide={handleCloseC}
                                  centered
                                  className="custom-gropmodelwel  roundedambdmodl roundedambdmodlcancel"
                                  backdrop={true}
                                >
                                  <Modal.Header className=" border-0">
                                    <img
                                      className=" border-0 closebtnevtn2 top-0 mt-4 mx-4 "
                                      src={require("../components/image/close.png")}
                                      alt="logo"
                                      onClick={handleCloseC}
                                    />
                                  </Modal.Header>
                                  <Modal.Title className="mx-5 "></Modal.Title>
                                  <Modal.Body className="mx-4 mt-sm-2">
                                    <div
                                      className=" fw-bold   text-center  w-100 ftzcopy   "
                                      style={{ fontSize: "21px" }}
                                    >
                                      Are you sure you want to cancel this event
                                    </div>

                                    <div
                                      className=" fw-bormal  mt-3 text-center  w-100 ftzcopy   "
                                      style={{ fontSize: "21px" }}
                                    >
                                      A cancellation e-mail will be sent to the
                                      current attendees.
                                    </div>
                                    <div className="d-flex justify-content-center mt-4">
                                      <button
                                        className="text-white subbtnmeet border-0 fs-5 fw600 rounded-2"
                                        style={{
                                          width: "150px",
                                          height: "44px",
                                          backgroundColor: "#62C0C7",
                                          textTransform: "capitalize",
                                        }}
                                        // onClick={handleCloseC}

                                        onClick={() => {
                                          handleCancelAttendance(book._id);
                                        }}
                                      >
                                        {lg?.cancel}
                                      </button>
                                    </div>
                                  </Modal.Body>
                                </Modal>
                              </Dropdown.Menu>
                            </div>
                          </Dropdown>

                          {/* Conditional Content */}
                          <div
                            key={index}
                            className={`z-3 d-none mt-2 p-2 oraginwid bg-white position-absolute ${
                              visibleCard1 === index ? "" : "d-none"
                            }`}
                            style={{
                              border: "1px solid #C1C1C1",
                              width: "240px",
                              height: "100px",
                            }}
                          >
                            <div>
                              <Form>
                                {["radio"].map((type) => (
                                  <div
                                    key={`inline-${type}`}
                                    className="fw-normal flxder pt-1"
                                    style={{ fontSize: "14px" }}
                                  >
                                    <Form.Check
                                      inline
                                      label="going"
                                      name={`group-${index}`}
                                      type={type}
                                      id={`inline-${type}-1-${index}`}
                                      onClick={handleGoing1}
                                      checked={selectedGoing[index] === "Going"}
                                      onChange={() =>
                                        handleOptionChangeGoing(index, "Going")
                                      }
                                    />
                                    <Form.Check
                                      inline
                                      label="not going"
                                      name={`group-${index}`}
                                      type={type}
                                      id={`inline-${type}-2-${index}`}
                                      // onClick={handleShowW}
                                      onClick={() => handleShowW(index)} // Open modal for this book

                                      // onChange={() => handleNotGoing(index)}
                                    />
                                  </div>
                                ))}
                              </Form>
                              {wShow === index && (
                                <Modal
                                  show={true}
                                  onHide={handleCloseW}
                                  centered
                                  className="custom-gropmodelwel roundedambdmodl"
                                  backdrop={true}
                                >
                                  <Modal.Header className=" border-0">
                                    <img
                                      className=" border-0 closebtnevtn2 top-0 mt-4 mx-4 "
                                      src={require("../components/image/close.png")}
                                      alt="logo"
                                      onClick={handleCloseW}
                                    />
                                  </Modal.Header>
                                  <Modal.Title className="mx-5 "></Modal.Title>
                                  <Modal.Body className="mx-4 mt-sm-2">
                                    <div
                                      className=" fw-bold   text-center  w-100 ftzcopy   "
                                      style={{ fontSize: "21px" }}
                                    >
                                      Are you sure that you no longer want to
                                      attend this event? The event will be
                                      removed from your dashboard.
                                    </div>
                                    <div className="d-flex justify-content-center mt-4">
                                      <button
                                        className="text-white subbtnmeet border-0 fs-5 fw600 rounded-2"
                                        style={{
                                          width: "150px",
                                          height: "44px",
                                          backgroundColor: "#62C0C7",
                                        }}
                                        onClick={() => handleNotGoing(index)}
                                      >
                                        Not going
                                      </button>
                                    </div>
                                  </Modal.Body>
                                </Modal>
                              )}
                            </div>
                            {/* )} */}
                            <div
                              className="fw600 text-decoration-underline"
                              style={{ fontSize: "13px", cursor: "pointer" }}
                              onClick={handleCancel1}
                            >
                              Cancel
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </div>
                  </Card>
                );
              })}
            </div>

            {/* coursol */}
            <div className=" my-4 jucfyy mx-0 d-sm-none d-block  ">
              {booksilentBooks?.length === 0 && "No events to be shown."}
              <Slider {...settings}>
                {booksilentBooks.map((book, index) => {
                  let spotsLeft =
                    Number(book?.maxAttendee) -
                    Number(book?.attendees?.length || 0);

                  return (
                    <div
                      key={book._id}
                      className="d-flex justify-content-center"
                    >
                      <Card
                        key={book._id}
                        className="border-0 align-items-center"
                        style={{ width: "" }}
                      >
                        <div className="d-sm-flex gap-2">
                          {book.image ? (
                            <div>
                              <Card.Img
                                className="ss"
                                variant="top"
                                src={resolveBookImageUrl(book.image)}
                                style={{
                                  width: "115px",
                                  height: "150px",
                                  objectFit: "contain",
                                  cursor: "pointer",
                                  opacity:
                                    book?.name == "Book Club"
                                      ? spotsLeft === 0
                                        ? 0.3
                                        : 1
                                      : 1,
                                }}
                                onClick={() => {
                                  const eventData = {
                                    type: book.name,
                                    location: book.city || "", // Use dynamic location
                                    link: book.link || "",
                                    title: book.title,
                                    image: book.image,
                                    author: book.author,
                                    pages: book.pageNumber,
                                    genre: book.genre,
                                    age: book.age,
                                    city: book.city,
                                    language: book.language,
                                    aboutBook: book.aboutBook,

                                    gender: book.gender,
                                    detail: book.description,
                                    eventType: book.type,
                                    createdAt: book?.dateInfo,
                                    time: book?.timeTrack,
                                    userId: book?.userId,
                                    meetingLink: book?.meetingLink,
                                    eventId: book._id,
                                    attendees: book?.attendees,
                                    LangLat: book?.location,
                                    // type:
                                    //   book.type.toLowerCase() === "on-line"
                                    //     ? "Book Duo"
                                    //     : "Book Club", // ✅ Condition Added
                                  };
                                  console.log("✅ Event Data:", eventData);
                                  localStorage.setItem(
                                    "eventDataNew",
                                    JSON.stringify(eventData)
                                  );
                                  handleEventTypeClick(book.name, book._id);
                                }}
                              />
                              {spotsLeft === 0 && book?.name == "Book Club" && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform:
                                      "translate(-50%, -50%) rotate(301deg)",
                                    color: "red",
                                    fontSize: "32px",
                                    fontWeight: "bold",
                                    border: "2px solid red",
                                    padding: "5px 15px",
                                    textTransform: "uppercase",
                                    backgroundColor: "rgba(255,255,255,0.6)",
                                    pointerEvents: "none",
                                  }}
                                >
                                  FULL
                                </div>
                              )}
                            </div>
                          ) : book.name === "Silent Reading" ? (
                            <div>
                              <Card.Img
                                className="imgsizsse157"
                                variant="top"
                                src={require("./image/book7.jpg")}
                                style={{
                                  width: "115px",
                                  height: "150px",
                                  objectFit: "contain",
                                  opacity:
                                    book?.name == "Silent Reading"
                                      ? spotsLeft === 0
                                        ? 0.3
                                        : 1
                                      : 1,
                                }}
                                onClick={() => {
                                  const eventData = {
                                    type: book.name,
                                    location: book.city || "", // Use dynamic location
                                    link: book.link || "",
                                    title: book.title,
                                    image: book.image,
                                    author: book.author,
                                    pages: book.pageNumber,
                                    genre: book.genre,
                                    age: book.age,
                                    city: book.city,
                                    language: book.language,
                                    gender: book.gender,
                                    detail: book.description,
                                    eventType: book.type,
                                    createdAt: book?.dateInfo,
                                    aboutBook: book.aboutBook,

                                    time: book?.timeTrack,
                                    userId: book?.userId,
                                    meetingLink: book?.meetingLink,
                                    eventId: book._id,
                                    attendees: book?.attendees,
                                    LangLat: book?.location,
                                    // type:
                                    //   book.type.toLowerCase() === "on-line"
                                    //     ? "Book Duo"
                                    //     : "Book Club", // ✅ Condition Added
                                  };
                                  console.log("✅ Event Data:", eventData);
                                  localStorage.setItem(
                                    "eventDataNew",
                                    JSON.stringify(eventData)
                                  );
                                  handleEventTypeClick(book.name, book._id);
                                }}
                              />
                              {spotsLeft === 0 &&
                                book?.name == "Silent Reading" && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: "50%",
                                      left: "50%",
                                      transform:
                                        "translate(-50%, -50%) rotate(301deg)",
                                      color: "red",
                                      fontSize: "32px",
                                      fontWeight: "bold",
                                      border: "2px solid red",
                                      padding: "5px 15px",
                                      textTransform: "uppercase",
                                      backgroundColor: "rgba(255,255,255,0.6)",
                                      pointerEvents: "none",
                                    }}
                                  >
                                    FULL
                                  </div>
                                )}
                            </div>
                          ) : (
                            <div
                              style={{
                                width: "115px",
                                height: "150px",
                                backgroundColor: "#e0e0e0",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#777",
                              }}
                              onClick={() => {
                                const eventData = {
                                  type: book.name,
                                  location: book.city || "", // Use dynamic location
                                  link: book.link || "",
                                  title: book.title,
                                  image: book.image,
                                  author: book.author,
                                  pages: book.pageNumber,
                                  genre: book.genre,
                                  age: book.age,
                                  city: book.city,
                                  language: book.language,
                                  gender: book.gender,
                                  detail: book.description,
                                  eventType: book.type,
                                  createdAt: book?.dateInfo,
                                  time: book?.timeTrack,
                                  userId: book?.userId,
                                  aboutBook: book.aboutBook,

                                  meetingLink: book?.meetingLink,
                                  eventId: book._id,
                                  attendees: book?.attendees,
                                  LangLat: book?.location,
                                  // type:
                                  //   book.type.toLowerCase() === "on-line"
                                  //     ? "Book Duo"
                                  //     : "Book Club", // ✅ Condition Added
                                };
                                console.log("✅ Event Data:", eventData);
                                localStorage.setItem(
                                  "eventDataNew",
                                  JSON.stringify(eventData)
                                );
                                handleEventTypeClick(book.name, book._id);
                              }}
                            >
                              No Image
                            </div>
                          )}
                          <Card.Body className="mt-0 p-0 text-center">
                            <Card.Title
                              className=" w-100 text-blakkck  fw-bold ftztfitle "
                              style={{
                                // color: "#6D6D6D",
                                fontSize: "15px",
                                maxWidth: "115px",

                                lineHeight:
                                  book.title[0] === "Before the coffee"
                                    ? "20px"
                                    : "25px", // Conditional line height

                                marginBottom:
                                  book.title[0] === "We Solve Murders with love"
                                    ? "5px"
                                    : "5px", // Conditional line height
                              }}
                            >
                              {book?.name === "Silent Reading"
                                ? "Your Own Book"
                                : book?.title?.slice(0, 14) || "Normal People"}
                            </Card.Title>
                            <Card.Text
                              className=" w-100 ftzgegrn fw-bold  m-0"
                              style={{
                                // color: "#383838",
                                color: "gray",
                                fontSize: "14px",
                                lineHeight: "20px",
                                maxWidth: "130px",
                              }}
                            >
                              {book?.name == "Book Duo"
                                ? "TBD"
                                : book?.dateInfo?.dayName +
                                  ",  " +
                                  book?.dateInfo?.day +
                                  " " +
                                  book?.dateInfo?.month +
                                  " " +
                                  book?.dateInfo?.year}
                              {/* book?.timeTrack?.minutes +
                            " " +
                            book?.timeTrack?.seconds} */}
                            </Card.Text>
                            <Card.Title
                              className=" ftzgegrn fw600  m-0"
                              style={{
                                fontSize: "15px",
                                color:
                                  book.name === "Book Duo"
                                    ? "#C55A11"
                                    : book.name === "Book Club"
                                    ? "#548235"
                                    : book.name === "Silent Reading"
                                    ? "#0070C0" // Blue for "Silent Reading"
                                    : "#000000", // Default color for other event types

                                lineHeight: "25px",
                              }}
                            >
                              {book?.name}
                            </Card.Title>
                            <Card.Title
                              className=" ftzggern fw600  m-0"
                              style={{
                                fontSize: "15px",

                                lineHeight: "25px",
                              }}
                            >
                              Age: {book?.age}
                            </Card.Title>
                            <div key={book._id}>
                              <Dropdown className="dropclnrt2">
                                <Dropdown.Toggle as="div">
                                  <button
                                    className="rounded-1 py-1 mt-3 editbtitn fw600 ftzgern fs-6 text-center text-dark"
                                    style={{
                                      border: "1px solid #383838",
                                      backgroundColor: "#F2F2F2",
                                      width: "80px",
                                      height: "auto",
                                    }}
                                    onClick={() => {
                                      const eventData = {
                                        type: book.name,
                                        location: book.city || "", // Use dynamic location
                                        link: book.link || "",
                                        title: book.title,
                                        image: book.image,
                                        author: book.author,
                                        pages: book.pageNumber,
                                        genre: book.genre,
                                        age: book.age,
                                        city: book.city,
                                        language: book.language,
                                        gender: book.gender,
                                        detail: book.description,
                                        eventType: book.type,
                                        createdAt: book?.dateInfo,
                                        time: book?.timeTrack,
                                        userId: book?.userId,
                                        meetingLink: book?.meetingLink,
                                        eventId: book._id,
                                        attendees: book?.attendees,
                                        LangLat: book?.location,
                                        // type:
                                        //   book.type.toLowerCase() === "on-line"
                                        //     ? "Book Duo"
                                        //     : "Book Club", // ✅ Condition Added
                                      };
                                      console.log("MAnhe ID", book._id);
                                      setGroupChatName(book);
                                      handleEditClick1(book._id);
                                    }}
                                  >
                                    {/* Manage */}
                                    {lg?.mang}
                                  </button>
                                </Dropdown.Toggle>
                                <div className="pualpicdrop  pualpicdropleadind">
                                  <Dropdown.Menu className="py-1 px-1 ">
                                    <Dropdown.Item
                                      className=" mt-1 fw600 text-dark"
                                      style={{
                                        lineHeight: "21.79px",
                                        borderBottom: "2px soild ",
                                        fontSize: "14px",
                                      }}
                                      onClick={handleQ6Show}
                                    >
                                      {/* Attendees list */}
                                      {lg?.attlist}
                                    </Dropdown.Item>

                                    <Dropdown.Item
                                      className=" mt-1 fw600 text-dark"
                                      style={{
                                        lineHeight: "21.79px",
                                        fontSize: "14px",
                                      }}
                                      onClick={() => {
                                        const eventData = {
                                          type: book.name,
                                          location: book.city || "", // Use dynamic location
                                          link: book.link || "",
                                          title: book.title,
                                          image: book.image,
                                          author: book.author,
                                          pages: book.pageNumber,
                                          genre: book.genre,
                                          age: book.age,
                                          city: book.city,
                                          language: book.language,
                                          gender: book.gender,
                                          detail: book.description,
                                          eventType: book.type,
                                          createdAt: book?.dateInfo,
                                          time: book?.timeTrack,
                                          userId: book?.userId,
                                          meetingLink: book?.meetingLink,
                                          eventId: book._id,
                                          attendees: book?.attendees,
                                          LangLat: book?.location,
                                          // type:
                                          //   book.type.toLowerCase() === "on-line"
                                          //     ? "Book Duo"
                                          //     : "Book Club", // ✅ Condition Added
                                        };
                                        console.log("Edit bOOk ID", book._id);

                                        navigate(`/silentReading/${book._id}`);
                                      }}
                                    >
                                      {/* Edit event */}
                                      {lg?.event}
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      className=" mt-1 fw600 text-dark"
                                      style={{
                                        lineHeight: "21.79px",
                                        fontSize: "14px",
                                        textTransform: "capitalize",
                                      }}
                                      onClick={() => {
                                        const eventData = {
                                          type: book.name,
                                          location: book.city || "", // Use dynamic location
                                          link: book.link || "",
                                          title: book.title,
                                          image: book.image,
                                          author: book.author,
                                          pages: book.pageNumber,
                                          genre: book.genre,
                                          age: book.age,
                                          city: book.city,
                                          language: book.language,
                                          gender: book.gender,
                                          detail: book.description,
                                          eventType: book.type,
                                          createdAt: book?.dateInfo,
                                          time: book?.timeTrack,
                                          userId: book?.userId,
                                          meetingLink: book?.meetingLink,
                                          eventId: book._id,
                                          attendees: book?.attendees,
                                          LangLat: book?.location,
                                          // type:
                                          //   book.type.toLowerCase() === "on-line"
                                          //     ? "Book Duo"
                                          //     : "Book Club", // ✅ Condition Added
                                        };
                                        handleShowC(true);
                                      }}
                                    >
                                      {/* Edit event */}
                                      {lg?.cancel}
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </div>
                              </Dropdown>
                            </div>
                          </Card.Body>
                        </div>
                      </Card>
                    </div>
                  );
                })}
              </Slider>
            </div>

            <div className=" mlmrleading d-none textczoom11 fontupcon fw-bold mt-5 fs-5">
              {/* All past events */}
              {lg?.allpst}
            </div>

            <div className="d-sm-flddex d-none flex-wrap  justzomag11  jucfyy paddleft mx-5 gap-3 mt-3">
              {bookspst.map((book, index) => (
                <Card
                  key={index}
                  className="border-0 align-items-center"
                  style={{ width: "" }}
                >
                  <div className="d-sm-flex gap-2">
                    <Card.Img
                      className="imgsize1111"
                      variant="top"
                      src={book.image}
                      style={{
                        width: "119px",
                        height: "170px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleEventTypeClick(book.eventType)}
                    />
                    <Card.Body className="mt-1 ">
                      <Card.Title
                        className=" w-100 text-black  fw-bold ftztitle "
                        style={{
                          // color: "#6D6D6D",
                          fontSize: "20px",
                          maxWidth: "210px",

                          lineHeight:
                            book.title[0] === "Before the coffee"
                              ? "20px"
                              : "30px", // Conditional line height

                          marginBottom:
                            book.title[0] === "We Solve Murders with love"
                              ? "5px"
                              : "15px", // Conditional line height
                        }}
                      >
                        {book.title[0]} <br /> {book.title[1]}
                      </Card.Title>
                      <Card.Text
                        className=" w-100 ftzgern fw-bold  m-0"
                        style={{
                          // color: "#383838",
                          color: "gray",
                          fontSize: "16px",
                          lineHeight: "25px",
                          maxWidth: "215px",
                        }}
                      >
                        {book.eventDate}
                      </Card.Text>
                      <Card.Title
                        className=" ftzgern fw600 fs-6 m-0"
                        style={{
                          color:
                            book.eventType === "Book Duo"
                              ? "#C55A11"
                              : book.eventType === "Book Club"
                              ? "#548235"
                              : book.eventType === "Silent Reading"
                              ? "#0070C0" // Blue for "Silent Reading"
                              : "#000000", // Default color for other event types

                          lineHeight: "25px",
                        }}
                      >
                        {book.eventType}
                      </Card.Title>
                      <Card.Title
                        className=" ftzgern fw600 fs-6 m-0"
                        style={{
                          color: "#000000",

                          lineHeight: "25px",
                        }}
                      >
                        {book.ageGroup}
                      </Card.Title>
                    </Card.Body>
                  </div>
                </Card>
              ))}
            </div>

            {/* coursol */}
            <div className=" my-4 d-none jucfyy mx-0 d-sm-none d-block  ">
              <Slider {...settings}>
                {bookspst.map((book, index) => (
                  <div key={index} className="d-flex justify-content-center">
                    <Card
                      key={index}
                      className="border-0 align-items-center"
                      style={{ width: "" }}
                    >
                      <div className="d-sm-flex gap-2">
                        <Card.Img
                          className="imgsizffe"
                          variant="top"
                          src={book.image}
                          style={{
                            width: "125px",
                            height: "170px",
                            cursor: "pointer",
                          }}
                          onClick={() => handleEventTypeClick(book.eventType)}
                        />
                        <Card.Body className="mt-0 p-0 text-center">
                          <Card.Title
                            className=" w-100 text-blakkck  fw-bold ftztfitle "
                            style={{
                              // color: "#6D6D6D",
                              fontSize: "15px",
                              maxWidth: "115px",

                              lineHeight:
                                book.title[0] === "Before the coffee"
                                  ? "20px"
                                  : "25px", // Conditional line height

                              marginBottom:
                                book.title[0] === "We Solve Murders with love"
                                  ? "5px"
                                  : "5px", // Conditional line height
                            }}
                          >
                            {book.title[0]} <br /> {book.title[1]}
                          </Card.Title>
                          <Card.Text
                            className=" w-100 ftzgegrn fw-bold  m-0"
                            style={{
                              // color: "#383838",
                              color: "gray",
                              fontSize: "14px",
                              lineHeight: "20px",
                              maxWidth: "130px",
                            }}
                          >
                            {book.eventDate}
                          </Card.Text>
                          <Card.Title
                            className=" ftzgegrn fw600  m-0"
                            style={{
                              fontSize: "15px",
                              color:
                                book.eventType === "Book Duo"
                                  ? "#C55A11"
                                  : book.eventType === "Book Club"
                                  ? "#548235"
                                  : book.eventType === "Silent Reading"
                                  ? "#0070C0" // Blue for "Silent Reading"
                                  : "#000000", // Default color for other event types

                              lineHeight: "25px",
                            }}
                          >
                            {book.eventType}
                          </Card.Title>
                          <Card.Title
                            className=" ftzggern fw600  m-0"
                            style={{
                              fontSize: "15px",

                              lineHeight: "25px",
                            }}
                          >
                            {book.ageGroup}
                          </Card.Title>
                        </Card.Body>
                      </div>
                    </Card>
                  </div>
                ))}
              </Slider>
            </div>
          </>
        )}
      </div>

      <div className="mt-5">
        <Footer2 />
      </div>

      <Modal
        show={q6Show}
        onHide={handleQ6Close}
        centered
        className="custom-modalques  customquset5 modelleadHight"
      >
        <Modal.Header className=" border-0">
          <img
            className=" border-0 closebtn mt-4 top-0"
            src={require("../components/image/close.png")}
            alt="logo"
            onClick={handleQ6Close}
          />
        </Modal.Header>
        <Modal.Title className="text-center  "></Modal.Title>

        <Modal.Body className="mx-auto  py-0  ">
          <div className="d-flex flex-wrap justify-content-center gapmodenew">
            {attendees.length === 0 ? (
              <div className="text-center fs-5 fw-bold ftzgern my-3 text-muted">
                No attendees yet.
              </div>
            ) : (
              attendees.map((book, index) => (
                <div
                  key={book._id}
                  className="d-sm-flex gap-3 text-center align-items-center"
                >
                  <img
                    // src={book.image}
                    className="imgpual rounded-circle "
                    src={
                      book?.profileImage
                        ? `${BASE_URL}/uploads/${book.profileImage}`
                        : require("../pages/image/addphotoicon.png")
                    }
                    alt={`${book?.name || "User"} photo`}
                    width="60"
                    height="60"
                    style={{ width: "60px", height: "60px" }}
                  />
                  <div
                    className="fs-5 ftzgern fw600 "
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      const eventData = {
                        type: book.name,
                        location: book.city || "", // Use dynamic location
                        link: book.link || "",
                        title: book.title,
                        image: book.image,
                        author: book.author,
                        pages: book.pageNumber,
                        genre: book.genre,
                        age: book.age,
                        city: book.city,
                        language: book.language,
                        gender: book.gender,
                        detail: book.description,
                        eventType: book.type,
                        createdAt: book?.dateInfo,
                        time: book?.timeTrack,
                        userId: book?.userId,
                        meetingLink: book?.meetingLink,
                        eventId: book._id,
                        attendees: book?.attendees,
                        LangLat: book?.location,
                        // type:
                        //   book.type.toLowerCase() === "on-line"
                        //     ? "Book Duo"
                        //     : "Book Club", // ✅ Condition Added
                      };
                      navigate(`/ambassadorprofile?id=${book?._id}`);
                    }}
                  >
                    {book?.name}
                  </div>
                </div>
              ))
            )}
          </div>

          <div
            className="fs-5 ftzevtt px-1 bebtnwid text-white mx-auto mt-sm-3 mt-5 w-100 py-sm-2 py-3 text-center fw-bold martambaa"
            style={{
              lineHeight: "40px",

              cursor: "pointer",
              // height: "48px",
              backgroundColor: "#34C3C9",
              maxWidth: "340px",
              // height:"30px",
              borderRadius: "10px",
            }}
            onClick={(e) => handleGroupChatCreation(e)}
          >
            {/* Chat with the group */}
            {lg?.chatgroup}
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={wShowCanc}
        onHide={handleCloseCanc}
        centered
        className="custom-gropmodelwel weldonemodel"
        backdrop={true}
      >
        <Modal.Header className=" border-0">
          <img
            className=" border-0 closebtnevtn24 mt-1 "
            style={{ top: "9px", right: "30px" }}
            src={require("../components/image/close.png")}
            alt="logo"
            onClick={handleCloseCanc}
          />
        </Modal.Header>
        <Modal.Title className="mx-5 ">
          <div
            className=" fw-bold mx-sm-2 text-center  aboutauther  "
            style={{ fontSize: "24px" }}
          >
            {/* Well done! */}
            Are you sure you want to cancel your RSVP?
          </div>
        </Modal.Title>
        <Modal.Body className="mx-4 pt-0 mt-sm-3 mt-2">
          <div
            className=" fw600 mx-lg-3 text-center mt-sm-3 mt-2   w-100 ftzcopy   "
            style={{ maxWidth: "900px", fontSize: "18px" }}
          >
            A cancellation e-mail will be sent to Ambassador.
          </div>
          <div className="mt-sm-4 mt-3 text-center ">
            <button
              onClick={() => {
                navigate(`/booksdetails/${bookSelected?._id}`);
              }}
              className="w-100 modelbtnjoin text-white ftzcopy text-center border-0 rounded-1 fw600 "
              style={{
                maxWidth: "162px ",
                fontSize: "22px",
                height: "45px",
                backgroundColor: "#34C3C9",
              }}
            >
              Cancel
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Leading;
